import { Button, ButtonOutlined, ButtonSpinner, ButtonTransparent } from '@components/common/Button/index.js';
import { shadowSoft } from '@components/previewUI/styles/global.js';
import { linkDesignTypes } from '@utils/enums.js';
import { bounceIn, fadeIn, flipInX, flipInY, jello, pulse, shake, swing, tada, zoomIn } from 'react-animations';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Box, Flex } from 'reflexbox/styled-components';
import styled, { css, keyframes } from 'styled-components';

const pulseAnimation = keyframes`${pulse}`;
const shakeAnimation = keyframes`${shake}`;
const tadaAnimation = keyframes`${tada}`;
const bounceInAnimation = keyframes`${bounceIn}`;
const fadeInAnimation = keyframes`${fadeIn}`;
const flipInXAnimation = keyframes`${flipInX}`;
const flipInYAnimation = keyframes`${flipInY}`;
const zoomInAnimation = keyframes`${zoomIn}`;
const swingAnimation = keyframes`${swing}`;
const jelloAnimation = keyframes`${jello}`;

export const Pulse = styled.div`
  animation: 2s ${pulseAnimation};
  animation-delay: 2s;
`;

export const Shake = styled.div`
  animation: 2s ${shakeAnimation};
  animation-delay: 2s;
`;

export const Tada = styled.div`
  animation: 2s ${tadaAnimation};
  animation-delay: 2s;
`;

export const BounceIn = styled.div`
  animation: 2s ${bounceInAnimation};
  animation-delay: 2s;
`;

export const FadeIn = styled.div`
  animation: 2s ${fadeInAnimation};
  animation-delay: 2s;
`;

export const FlipInX = styled.div`
  animation: 2s ${flipInXAnimation};
  animation-delay: 2s;
`;

export const FlipInY = styled.div`
  animation: 2s ${flipInYAnimation};
  animation-delay: 2s;
`;

export const ZoomIn = styled.div`
  animation: 2s ${zoomInAnimation};
  animation-delay: 2s;
`;

export const Swing = styled.div`
  animation: 2s ${swingAnimation};
  animation-delay: 2s;
`;

export const Jello = styled.div`
  animation: 2s ${jelloAnimation};
  animation-delay: 2s;
`;

export const LinkStyles = css`
  font-size: 16px;
  line-height: 24px;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s;
  color: var(--main-black);
  padding-bottom: 5px;
  cursor: pointer;

  &:hover {
    color: darkgray;
  }
`;

export const Link = styled.a`
  ${LinkStyles};

  ${(props) =>
    props.isLogOut &&
    css`
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    `}

  ${(props) =>
    props.isMobileMenu &&
    css`
      color: #fff;
    `}

  ${(props) =>
    props.isDashboardMenu &&
    css`
      margin: 0;
      padding: 0;
    `}
  
  ${(props) =>
    props.isAccountMenu &&
    css`
      margin: 0;
      padding: 2px 0;
    `}
`;

export const NavLink = styled(RouterNavLink)`
  ${LinkStyles};

  &.${(props) => props.activeClassName} {
    color: #a05f83;
    border-color: #a05f83;
  }
`;

export const User = styled(Box)`
  padding-bottom: 5px;

  ${(props) =>
    props.isEmail &&
    css`
      cursor: pointer;
      overflow: hidden;
      max-width: 255px;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;
    `}

  ${(props) =>
    props.isDashboardRoute &&
    css`
      max-width: 355px;
      font-size: 18px;
    `}

  ${(props) =>
    props.isShowingMobileMenu &&
    css`
      line-height: 24px;
    `}
`;

export const ErrorText = styled(Box)`
  color: red;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
  text-align: left;

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.isHide &&
    css`
      height: 19px;
      opacity: 0;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}
  
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const Container = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
    `}
  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const FlexWrap = styled.div`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: ${(props) => props.justifyContent || 'flex-end'};
  align-items: ${(props) => props.alignItems || 'іstart'};

  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;

  @media (max-width: 767px) {
    display: flex;
    width: ${(props) => props.width || '78%'};
    flex-direction: row;
    justify-content: space-between;
  }

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
      flex-shrink: 0;
      @media (max-width: 767px) {
        flex-direction: column;
        width: unset;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideTikTok &&
    css`
      @media (max-width: 768px) {
        align-items: center;
      }
    `}


  ${(props) =>
    props.insideLook &&
    css`
      @media (max-width: 767px) {
        justify-content: flex-end;
      }
    `}
  ${(props) =>
    props.isRelative &&
    css`
      position: relative;
    `}
`;

export const MobButtonWrap = styled.div`
  @media (max-width: 767px) {
    width: 48%;
    padding: 0;
    margin: 0;
  }

  ${(props) =>
    props.insideLinks &&
    css`
      @media (max-width: 767px) {
        width: 100%;
      }
    `}

  ${(props) =>
    props.isUpdatingMusic &&
    css`
      display: flex;
      justify-content: flex-end;
    `}
  
  ${(props) =>
    props.rightCorner &&
    css`
      margin-left: auto;
    `}

  ${(props) =>
    props.center &&
    css`
      display: flex;
      justify-content: center;
    `}
`;

export const DeleteImgMob = styled.img`
  max-height: 38px;

  ${(props) =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
`;

export const ActionButtons = styled(Box)`
  display: flex;

  @media (max-width: 767px) {
    justify-content: center;
  }

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      padding-bottom: 30px;
    `}

  ${(props) =>
    props.insideLinks &&
    css`
      @media (max-width: 767px) {
        margin-top: 30px !important;
        margin-left: auto;
        width: 100px;
      }
    `}

  ${(props) =>
    props.insideSettings &&
    css`
      @media (max-width: 767px) {
        justify-content: space-between;
      }
    `}


  ${(props) =>
    props.insideTikTok &&
    css`
      @media (max-width: 767px) {
        justify-content: flex-start;
      }
    `}

  ${(props) =>
    props.insideMusic &&
    css`
      @media (max-width: 767px) {
        justify-content: flex-end;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.flexEnd &&
    css`
      justify-content: flex-end;

      @media (max-width: 767px) {
        justify-content: flex-end;
      }
    `}


  ${(props) =>
    props.customItems &&
    css`
      margin-top: 51px;
      margin-left: auto;
    `}

  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}
`;

export const MobButtonWrapDelete = styled.div`
  @media (max-width: 767px) {
    margin-right: 24px;
    width: 18%;
    line-height: 1.4em;
    padding: 0;
  }
`;

export const Subcaption = styled(Box)`
  display: inline;

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
    ${(props) =>
    props.mailingDesc &&
    css`
      font-size: 12px;
      color: var(--secondary-gray);
      flex-deirection: column;
      @media (max-width: 650px) {
        margin-top: 10px;
        padding: 10px 0 0 0;
      }
    `}
`;

export const InputBlockBox = styled(Box)`
  position: relative;

  ${(props) =>
    props.notifsEmail &&
    css`
      align-items: center;
      display: flex;
    `}

  ${(props) =>
    props.isSectionSettings &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const InputBlockChangeLink = styled(Box)`
  display: flex;
  align-items: flex-end;
  margin: 0 0 3px 30px;
  color: #007aff;
  cursor: pointer;
  text-decoration: underline;

  ${(props) =>
    props.notification &&
    css`
      margin: 0;
      margin-left: auto;
    `}
  ${(props) =>
    props.notification &&
    css`
      align-items: center;
    `}
`;

export const InputIcon = styled.img`
  position: absolute;
  top: 6px;
  left: 10px;
  width: 30px;
  height: 30px;

  ${(props) =>
    props.gmailIcon &&
    css`
      top: 9px;
      left: 12px;
      width: 25px;
      height: 25px;
    `}

  ${(props) =>
    props.selzyIcon &&
    css`
      width: 30px;
      height: 30px;
      top: 5px;
      left: 5px;
    `}
`;

export const InputIconBox = styled(Box)`
  position: absolute;
  top: 6px;
  left: 10px;
  width: 30px;
  height: 30px;

  ${(props) =>
    props.isInsideMigrate &&
    css`
      transform: rotate(-45deg);
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      width: 14px;
      height: 14px;
      position: relative;
      top: -4px;
      left: 2px;
    `}
`;

// <!-- start copy of Post.js
export const TextareaBox = styled(Box)`
  position: relative;
  width: 100%;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const EmojiPickerWrap = styled(Box)`
  position: fixed;
  right: -9999px;
  z-index: 1000;
  transition: opacity 0.2s;
  opacity: 0;
  overflow: hidden;

  ${(props) =>
    props.visible &&
    css`
      position: absolute;
      opacity: 1;
      overflow: visible;

      @media (max-width: 992px) {
        top: 0;
        right: 0;
      }

      @media (min-width: 993px) {
        top: -110px;
        right: -40px;
      }
    `}
`;
// <!-- end copy of Post.js

export const PhotoList = styled(Flex)`
  flex: 1;
  flex-wrap: wrap;
  // justify-content: center;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: block;
  }

  ${(props) =>
    props.templateList &&
    css`
      @media (min-width: 768px) {
        margin-left: 0;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.justify &&
    css`
      justify-content: ${props.justyfy};
    `}
`;

export const EmptyPhotoList = styled(Flex)`
  padding: 40px 0;
  width: 100%;
  text-align: center;
  justify-content: center;
`;

export const LookDeleteBoxItem = styled(Box)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
  display: none;

  ${(props) =>
    props.isGallery &&
    css`
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: var(--main-gray);
      opacity: 0.5;
    `}
`;

export const PhotoBox = styled(Box)`
  width: 30%;
  position: relative;
  margin-bottom: 10px;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  &:hover {
    cursor: pointer;
  }

  &:hover ${LookDeleteBoxItem} {
    display: block;
  }

  @media (min-width: 768px) {
    margin-right: 10px;
    width: 30%;
    height: 0;
    padding-bottom: 30%;

    ${(props) =>
      props.third &&
      css`
        margin-right: 0;
      `}
  }

  @media (min-width: 1200px) {
    width: 30%;
    height: 0;
  }

  @media (max-width: 768px) {
    display: inline-block;
    vertical-align: initial;
    width: 48%;
    margin-right: 3.5%;
    margin-bottom: 3%;
    padding-top: 48%;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 12px;

    &:nth-child(2n + 2) {
      margin-right: 0;
    }
  }

  ${(props) =>
    props.isList &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: transparent;
      color: #0155fa;
      font-weight: bold;
      text-align: center;
      border: 2px dashed rgba(1, 85, 250, 0.3);
      border-radius: 8px;

      @media (min-width: 1200px) {
        padding-bottom: 30%;
      }

      @media (max-width: 768px) {
        display: inline-flex;
        padding-top: 47.5%;
      }

      @media (max-width: 568px) {
        padding-top: 46.5%;
      }

      &:hover {
        background: transparent;
        border-color: #0155fa;
      }

      ${(props) =>
        props.isInsideLook &&
        css`
          margin-right: 0 !important;

          @media (min-width: 1200px) {
            width: 23.6%;
            height: 0;
            padding-bottom: 23.6%;
          }

          ${LookDeleteBoxItem} {
            display: none;
          }

          &:hover ${LookDeleteBoxItem} {
            display: block;
          }
        `}
    `}

  ${(props) =>
    props.uploadPhoto &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: transparent;
      color: #0155fa;
      font-weight: bold;
      text-align: center;
      border: 2px dashed rgba(1, 85, 250, 0.3);
      border-radius: 8px;

      @media (min-width: 1200px) {
        padding-bottom: 30%;
      }

      @media (max-width: 768px) {
        display: inline-flex;
        padding-top: 47.5%;
      }

      @media (max-width: 568px) {
        padding-top: 46.5%;
      }

      &:hover {
        background: transparent;
        border-color: #0155fa;
      }

      ${(props) =>
        props.isInsideLook &&
        css`
          margin-right: 0 !important;

          @media (min-width: 1200px) {
            width: 23.6%;
            height: 0;
            padding-bottom: 23.6%;
          }

          ${LookDeleteBoxItem} {
            display: none;
          }

          &:hover ${LookDeleteBoxItem} {
            display: block;
          }
        `}
    `}

  ${(props) =>
    props.uploadMediaGallery &&
    css`
      position: relative;

      @media (min-width: 1200px) {
        width: 60px;
        height: 60px;
        padding-bottom: 0;
      }

      @media (max-width: 768px) {
        width: 60px;
        height: 60px;
        padding-bottom: 0;
      }

      @media (min-width: 768px) {
        width: 60px;
        height: 60px;
        padding-bottom: 0;
      }
    `}

  ${(props) =>
    props.uploadDigitalImage &&
    css`
      position: relative;

      width: 150px;
      height: 150px;
      padding: 0;

      @media (min-width: 1200px) {
        width: 150px;
        height: 150px;
        padding: 0;
      }

      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
        padding: 0;
      }

      @media (min-width: 768px) {
        width: 150px;
        height: 150px;
        padding: 0;
      }
    `}

  ${(props) =>
    props.uploadTikTok &&
    css`
      position: relative;
      padding-bottom: 54%;
      width: 30.8%;

      @media (min-width: 1200px) {
        padding-bottom: 54%;
      }

      @media (min-width: 768px) {
        padding-bottom: 54%;
        padding-top: 0;
      }

      @media (max-width: 768px) {
        padding-bottom: 54%;
        padding-top: 0;
        margin-right: 10px;
      }
    `}
  
  ${(props) =>
    props.hide &&
    css`
      display: none !important;
    `}

  ${(props) =>
    props.editBox &&
    css`
      @media (max-width: 768px) {
        width: 45%;
        padding-top: 45%;
        border-radius: 8px;
      }
    `}


  ${(props) =>
    props.isInsideLook &&
    css`
      @media (min-width: 1200px) {
        width: 23.6%;
        height: 0;
        padding-bottom: 23.6%;
      }
    `}


  ${(props) =>
    props.isInstagramList &&
    css`
      overflow: hidden;

      @media (min-width: 1200px) {
        width: 100%;
        padding-bottom: 100%;
      }
    `}

  ${(props) =>
    props.itemGrid &&
    css`
      @media (min-width: 768px) {
        width: 100%;
        padding-bottom: 100%;
      }
    `}

${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}

${(props) =>
    props.aspectRatio &&
    css`
      aspect-ratio: ${props.aspectRatio};
    `}
`;

export const ShopItemGrid = styled(Box)`
  margin-right: 10px;
  margin-bottom: 20px;

  &:nth-child(3n + 3) {
    margin-right: 0;
  }

  &:nth-child(2) {
    margin-right: 10px;
  }

  ${(props) =>
    props.galleryItem &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.isShop &&
    css`
      width: 31.5%;
    `}
`;

export const PhotoTitleBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.editBox &&
    css`
      display: none;
    `}
`;

export const PhotoTitle = styled(Box)`
  margin: 25px 0;
  font-size: 28px;
  font-weight: bold;

  @media (max-width: 768px) {
    text-align: center;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PhotoText = styled(Box)`
  text-align: center;
  margin-bottom: 35px;
`;

export const PhotoBoxUploadIcon = styled(Box)`
  position: absolute;
  top: 40px;
  width: 32px;
  height: 32px;
  
  &:before, &:after {
    position: absolute;
    left: 14px;
    content: ' ';
    height: 65px;
    width: 2.5px;
    background-color: #0155fa;

    @media (max-width: 768px) {
      height: 50px;
      width: 2px;
      left: 25px;
    }
  }
  
  &:before {
    transform: rotate(0deg);
  }
  
  &:after {
    transform: rotate(-90deg);
  }

  @media (max-width: 768px) {
    top: 30px;
    height: 50px;
    width: 50px;
  }

  ${(props) =>
    props.uploadMediaGallery &&
    css`
      top: 21px;
      left: 13px;

      &:before,
      &:after {
        height: 14px;
        width: 2.5px;

        @media (max-width: 568px) {
          height: 14px;
          width: 2px;
        }
      }

      @media (max-width: 768px) {
        top: 22px;
        left: 3px;
      }
    `}

  ${(props) =>
    props.uploadDigitalImage &&
    css`
      padding-top: 5px;
      top: initial;
      left: initial;

      @media (max-width: 768px) {
        top: initial;
        left: initial;
      }
    `}
  

  ${(props) =>
    props.uploadTikTok &&
    css`
      top: 85px;
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      top: 30px;
      width: 30px;
      height: 30px;

      &:before,
      &:after {
        left: 15px;
        height: 50px;
        width: 1.5px;

        @media (max-width: 768px) {
          left: 25px;
        }
      }
    `}

  ${(props) =>
    props.width &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: ${props.width};
      height: ${props.width};

      &:before,
      &:after {
        width: 2px;
        height: ${props.width};
      }
    `}


}
`;

export const PhotoBoxUploadTitle = styled(Box)`
  position: absolute;
  bottom: 30px;

  @media (max-width: 1200px) {
    font-size: 14px;
    bottom: 22px;
  }

  ${(props) =>
    props.uploadTikTok &&
    css`
      bottom: 125px;
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      bottom: 25px;
      font-size: 12px;
    `}
`;

export const PhotoImg = styled.img`
  display: flex;
  align-self: end;
  max-width: 100%;
  min-height: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;

  @media (min-width: 1200px) {
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;

    ${(props) =>
      props.checked &&
      css`
        border: 3px #17ce17 solid;
        border-radius: 8px;
        opacity: 1;
      `}
  }

  ${(props) =>
    props.isBorder &&
    css`
      border: 1px solid #ebeef1;
      border-radius: 8px;
    `}

  ${(props) =>
    props.checked &&
    css`
      border: 3px #17ce17 solid;
      border-radius: 8px;
      opacity: 1;
    `}

 
  
  ${(props) =>
    !props.isEdit &&
    css`
      opacity: 0.5;
      filter: grayscale(100%);
    `}

  ${(props) =>
    props.isInstagramList &&
    css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    `}

  ${(props) =>
    props.cover &&
    css`
      object-fit: cover;
    `}


  ${(props) =>
    props.lookProdcut &&
    css`
      position: absolute;
      object-fit: cover;
    `}
`;

// modal
export const ModalInnerWrap = styled(Flex)`
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  // max-height: ${(props) => props.maxHeight || '700px'};
  max-height: ${(props) => props.maxHeight};
  -moz-appearance: none;
  -webkit-appearance: none;
  overflow-y: unset;

  @media (max-width: 767px) {
    max-height: none;
  }

  ${(props) =>
    props.isAnalytics &&
    css`
      padding: 0 3rem;

      @media (max-width: 480px) {
        padding: 0;
        margin-bottom: 80px;
      }
    `}

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight}px;
    `}

  ${(props) =>
    props.isNotPremium &&
    css`
      pointer-events: none;
      opacity: 0.3;
    `}

  ${(props) =>
    props.blogPost &&
    css`
      justify-content: flex-start;
      height: 100%;
    `}

  ${(props) =>
    props.scrollY &&
    css`
      overflow-y: scroll;
      padding-right: 12px;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ModalContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
  padding: 10px 12px 0;
`;

export const ModalSubtitle = styled(Box)`
  font-size: 16px;

  span {
    cursor: pointer;
    color: #4e75fe;
  }

  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}
`;

export const ModalText = styled(Box)`
  font-size: 16px;
`;

export const ModalEmoji = styled(Box)`
  font-size: 45px;
  text-align: center;
`;

export const ModalDisconnectButtons = styled(Flex)`
  justify-content: space-evenly;

  @media (max-width: 576px) {
    gap: 15px;
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
    `}

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}

  ${(props) =>
    props.insideFaq &&
    css`
      margin-top: 32px;

      @media (max-width: 767px) {
        margin-top: 0;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideCollect &&
    css`
      margin-top: 20px;
    `}
`;

export const CancelModalButton = styled(Button)`
  width: 30%;
  background: var(--main-background);
  color: var(--main-black);
`;

export const CancelModalButtonMain = styled(Button)`
  width: 30%;
  background: var(--main-background);
  color: var(--main-black);
  
  bor
  
`;

export const SaveModalButton = styled(ButtonSpinner)`
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PublishButton = styled(ButtonSpinner)`
  padding: 0 12px;

  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;

  border-radius: 36px;
  background: #5a41f5;
  border-color: #5a41f5;

  &:hover {
    background: #5a41f5;
    border-color: #5a41f5;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
      border-color: ${props.background};

      &:hover {
        background: ${props.background};
        border-color: ${props.background};
      }
    `}
`;

export const PublishButtonIcon = styled.img`
  width: 21px;
  height: 21px;
`;

export const CancelButton = styled(ButtonOutlined)`
  width: 30%;
  min-height: 32px;
  padding: 0 16px;
  line-height: 32px;
`;

export const SaveButton = styled(Button)`
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalSpinnerBox = styled(Flex)`
  margin-left: 10px;

  ${(props) =>
    props.savingBot &&
    css`
      margin-top: 2px;
      margin-left: 8px;
    `}
`;

export const ModalContentWrap = styled(Flex)`
  @media (max-width: 767px) {
    flex-direction: column;
  }

  @media (min-width: 768px) {
    justify-content: space-between;
  }

  @media (max-width: 992px) {
    ${(props) =>
      props.actionModal &&
      css`
        flex-direction: column;
      `}
  }

  ${(props) =>
    props.product &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const ModalImageBox = styled(Box)`
  position: relative;
  width: 345px;
  margin-bottom: 10px;

  @media (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 568px) {
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideShop &&
    css`
      width: 150px;
      height: 150px;

      @media (max-width: 768px) {
        margin: 0;
      }
    `}

  ${(props) =>
    props.isProductPreview &&
    css`
      width: 100%;
      height: 350px;
    `}
`;

export const ModalImageTextBox = styled(Box)`
  position: relative;
  width: 345px;
  padding: 20px 46px 20px 20px;
  background: #100629;
  border-radius: 6px;
  overflow: hidden;
  word-wrap: break-word;

  @media (max-width: 568px) {
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isLink &&
    css`
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      word-wrap: break-word;
    `}

  ${(props) =>
    props.isButtonLink &&
    css`
      padding: 17px 20px;
    `}
  

  ${(props) =>
    props.buttonLinkRightArrow &&
    css`
      padding: 0 46px;
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isLinkButtonImagePreview &&
    css`
      padding-left: 70px;
      padding-right: 70px;
    `}

  ${(props) =>
    props.borderBottomRadius &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}

  ${(props) =>
    props.buttonShape === 'cover' &&
    props.image &&
    css`
      background: url(${props.image}) no-repeat center / cover;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${props.background};
        opacity: 0.2;
      }
    `}

  ${(props) =>
    props.buttonShape === 'full' &&
    props.image &&
    css`
      padding-left: 38%;
    `}


  ${(props) =>
    props.paddingTop &&
    props.buttonShape === 'card' &&
    css`
      padding-top: ${props.paddingTop + 12}px;
      padding-bottom: 15px;

      @media (max-width: 797px) {
        padding-top: ${props.paddingTop + 12}px;
      }
    `}

  ${(props) =>
    props.linkHeight &&
    props.buttonShape !== 'card' &&
    css`
      min-height: ${props.linkHeight}px;

      @media (max-width: 797px) {
        min-height: ${props.linkHeight}px;
      }
    `}

  ${(props) =>
    props.isButtonRadius &&
    css`
      border-radius: 36px;
    `}



  ${(props) =>
    props.isBorder &&
    css`
      outline: 2px solid ${props.textColor};
    `}

  ${(props) =>
    props.isTopBottomPadding &&
    css`
      padding-top: 17px;
      padding-bottom: 17px;
    `}


  ${(props) =>
    props.digital &&
    css`
      padding: 15px;
      min-height: 98px;
    `}


  ${(props) =>
    props.digital &&
    props.buttonShape === 'card' &&
    css`
      padding-top: 75px;
    `}

  ${(props) =>
    props.previewItem &&
    css`
      margin-bottom: 12px;
    `}


  ${(props) =>
    props.digital &&
    props.buttonShape === 'card' &&
    css`
      padding-top: 285px;
    `}

  ${(props) =>
    props.digital &&
    (props.background === '#fff' || props.background === '#ffffff' || props.background === 'white') &&
    css`
      outline: 1px solid var(--border-color);
    `}

    ${(props) =>
    props.buttonShape === 'squareEvents' &&
    props.image &&
    css`
      background: url(${props.image}) no-repeat center / cover;
      padding-top: 30%;
      border-radius: 16px;
      margin: 0 auto;
      justify-content: end;
    `}
      
    ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
    ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}

    ${(props) =>
    props.isNoOutline &&
    css`
      outline: none;
    `}

    ${(props) =>
    props.isEvents &&
    props.buttonShape === 'ticket' &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: start;
      gap: 64px;
      min-height: 128px;
    `}

  ${(props) =>
    props.buttonShape === linkDesignTypes.round &&
    css`
      padding-left: 24px;
      padding-right: 24px;
    `}

    ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}
  
  ${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
  ${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}
  
    ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
    ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
  
    ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}

  ${({ shape }) =>
    shape === 'square' &&
    css`
      border-radius: 8px !important;
      &:hover {
        border-radius: 8px !important;
      }
    `}
  
    ${({ shape }) =>
    shape === 'round' &&
    css`
      border-radius: 36px !important;
      &:hover {
        border-radius: 36px !important;
      }
    `}
`;

export const ModalImageTitle = styled(Box)`
  //max-height: 23px;
  overflow: hidden;

  font-size: 18px;
  font-weight: bold;
  color: #fff;

  ${(props) =>
    props.isMarginBottom &&
    css`
      margin-bottom: 5px;
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.digital &&
    css`
      padding-left: 80px;
    `}

  ${(props) =>
    props.digital &&
    (props.buttonShape === 'card' || props.buttonShape === 'cover') &&
    css`
      padding-left: 15px;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      padding-left: 36%;

      @media (max-width: 568px) {
        padding-left: 36%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      padding-left: 36%;
    `}

  ${(props) =>
    props.buttonShape === 'square' &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.button &&
    css`
      padding-left: 0;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

    ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}
`;

export const ModalImageLinkButtonBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 10px;
  width: 49px;
  height: 49px;
  margin-top: -24px;
  border-radius: 4px;
  cursor: pointer;
  cursor: pointer;

  @media (max-width: 568px) {
    width: 30px;
    height: 30px;
  }

  ${(props) =>
    props.border &&
    css`
      border: 1px solid var(--border-color);
    `}
  ${(props) =>
    props.buttonLinkContainer &&
    css`
      flex: none;
      position: static;
      margin: 0 20px 0 0;

      @media (max-width: 568px) {
        margin: 0 8px 0 0;
      }
    `}

  ${(props) =>
    props.buttonShape === 'full' &&
    css`
      top: 0;
      left: 0;
      width: 33%;
      height: 100%;
      margin-top: 0;
    `}

  ${(props) =>
    props.buttonShape === 'card' &&
    css`
      top: 0;
      left: 0;
      margin: 0;
      width: 100%;
      height: ${props.height}px;
    `}

  ${(props) =>
    props.digital &&
    css`
      top: 12px;
      margin-top: 0;
    `}
  
  ${(props) =>
    props.digital &&
    (props.buttonShape === 'round' || props.buttonShape === 'square') &&
    css`
      width: 75px;
      height: 75px;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      top: 0;

      @media (max-width: 568px) {
        width: 33%;
        height: 100%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    props.isInsideDashboard &&
    css`
      width: 33%;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.card &&
    css`
      top: 0;

      @media (max-width: 568px) {
        width: 100%;
        height: 100%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === 'full' &&
    css`
      @media (max-width: 568px) {
        height: 100%;
      }
    `}


  ${(props) =>
    props.coupon &&
    css`
      flex: none;
      position: static;
      margin: 0;
      width: 100px;
      height: 100px;
      overflow: hidden;
    `}

  ${(props) =>
    props.isMarginBottom &&
    css`
      margin-bottom: 10px;
    `}
`;

export const ModalImageLinkButtonIcon = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 4px;
  

  @media (max-width: 568px) {
    width: 30px;
    height: 30px;
  }

  ${(props) =>
    props.border &&
    css`
      border: 1px solid var(--border-color);
    `}
  ${(props) =>
    props.buttonShape === 'round' &&
    css`
      border-radius: 50%;
    `}

  ${(props) =>
    props.buttonShape === 'full' &&
    css`
      border-radius: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;

      @media (max-width: 568px) {
        width: 90px;
        height: 100%;
      }
    `}

  ${(props) =>
    props.digital &&
    (props.buttonShape === 'round' || props.buttonShape === 'square') &&
    css`
      width: 75px;
      height: 75px;
      object-fit: cover;

      @media (max-width: 568px) {
        width: 75px;
        height: 75px;
      }
    `}
 

}


  
  
  ${(props) =>
    props.buttonShape === 'full' &&
    props.digital &&
    props.isButton &&
    css`
      width: 100%;
      height: 100%;

      @media (max-width: 568px) {
        width: 100%;
        height: 100%;
      }
    `}


  ${(props) =>
    props.buttonShape === 'card' &&
    css`
      width: 100%;
      height: ${props.height}px;
      object-fit: cover;
      border-radius: 0;
    `}


  ${(props) =>
    props.digital &&
    props.buttonShape === 'card' &&
    css`
      width: 100%;
      height: 265px;
      object-fit: cover;
      border-radius: 0;

      @media (max-width: 568px) {
        width: 100%;
        height: 265px;
      }
    `}

  ${(props) =>
    props.coupon &&
    css`
      width: 100px;
      height: 100px;
      border-radius: 0;
    `}
`;

export const PreWrapText = styled.div`
  white-space: pre-wrap;
  max-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(props) =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}
`;

export const ModalImageText = styled(Box)`
  max-height: 55px;
  overflow: hidden;
  color: #fff;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.insideLinks &&
    css`
      max-height: initial;
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.digital &&
    css`
      padding-left: 80px;
      font-size: 14px;
    `}

  ${(props) =>
    props.digital &&
    (props.buttonShape === 'card' || props.buttonShape === 'cover') &&
    css`
      padding-left: 15px;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      padding-left: 36%;

      @media (max-width: 568px) {
        padding-left: 36%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    props.isInsideDashboard &&
    css`
      padding-left: 36%;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.button &&
    css`
      padding-left: 0;
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
      border-radius: 16px;
      width: fit-content;
      padding: 4px 16px;
      margin-top: 4px;
      margin-left: 16px;
    `}

    ${(props) =>
    props.lessPadding &&
    css`
      padding-lef: 36%;
    `}
    ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
    ${(props) =>
    props.flex &&
    css`
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: 0;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
    
    ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}

    ${(props) =>
    props.links &&
    props.buttonShape === linkDesignTypes.round &&
    css`
      padding-left: 45px;
      padding-right: 25px;
    `}
`;

export const ActionModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 450px;

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }

  ${(props) =>
    props.isLesson &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.addUrlType &&
    css`
      width: 100%;
      min-height: 235px;
    `}

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.modalLink &&
    css`
      width: 100%;
      max-width: 675px;
      margin-right: 50px;
    `}
}
`;

export const CustomSpan = styled.span`
  ${(props) =>
    props.addProduct &&
    css`
      font-size: 20px;
      margin-right: 5px;
      color: #fff;
    `}
`;

export const DeleteBlackImg = styled.img`
  height: 24px;
  display: block;

  ${(props) =>
    props.deleteTag &&
    css`
      height: 16px;
    `}
`;

export const ActionButton = styled(ButtonOutlined)`
  display: inline-flex;
  width: 48%;
  margin: 0 0 10px;
  padding: 0 10px;
  align-items: center;
  text-align: left;
  font-weight: 700;
  font-size: 14px;
  color: var(--text-tertiary);
  background: #f8f8f8;
  border: 1px solid #f8f8f8;

  &:hover {
    color: #489be0;
    border: 1px solid #489be0;
  }

  &:disabled {
    &:hover {
      color: var(--secondary-gray);
      background: var(--main-gray);
      border: 1px solid #eeeff1;
    }
  }

  ${(props) =>
    props.active &&
    css`
      background: #489be0;
      border: 1px solid #489be0;
      color: #fff;

      &:hover {
        color: #fff;
        border: 1px solid #489be0;
        background: #489be0;
      }
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: 767px) {
        width: 100%;
      }
    `}
  
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
  
  ${(props) =>
    props.small &&
    css`
      min-height: 32px;
      max-height: 32px;
      line-height: 32px;
    `}
  
  
  ${(props) =>
    props.uploadTagImage &&
    css`
      width: auto;
    `}

  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}
`;

export const ActionButtonIcon = styled.span`
  width: 30px;
  margin-right: 10px;

  @media (max-width: 767px) {
    margin-left: 10px;
  }

  ${(props) =>
    props.marginRight &&
    css`
      margin-right: ${props.marginRight};
    `}
`;

export const ActionButtonIconImg = styled.img`
  display: block;
  max-width: 100%;
  margin: 0 auto;
`;

export const AddedMark = styled(Box)`
  min-width: 60px;
  text-align: center;
  padding: 5px 10px;
  background: #17ce17;
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: white;
  border-radius: 12px;
  font-size: 13px;

  ${(props) =>
    !props.isHide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.tikTokItem &&
    css`
      bottom: 20px;

      @media (max-width: 567px) {
        bottom: 10px;
      }
    `}
`;

export const StatisticMenuHiddenBox = styled(Box)`
  position: absolute;
  top: 5px;
  right: 0;
  border-radius: 20px;
  border: 1px solid var(--border-color, #e5e7eb);

  [data-theme='dark'] & {
    border-color: var(--border-color);
  }

  ${(props) =>
    props.modalAnalytics &&
    css`
      position: static;
      display: flex;
      justify-content: flex-end;

      @media (max-width: 568px) {
        position: relative;
        top: 0;
        justify-content: flex-end;
        width: 100%;
        z-index: 15;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      justify-content: flex-start;
      position: relative;
      top: 38px;
    `}

  ${(props) =>
    props.isProducts &&
    css`
      min-width: 150px;
      min-height: 42px;
      top: 0;
      @media (max-width: 480px) {
        width: 100%;
      }
    `}
`;

export const StatisticMenuDots = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 15px;
  cursor: pointer;

  //outline: 1px dashed deeppink;

  ${(props) =>
    props.modalAnalytics &&
    css`
      position: relative;
      font-size: 14px;
      color: var(--secondary-gray);
      //width: 130px;
      z-index: 1;

      @media (max-width: 568px) {
        width: auto;
        z-index: 15;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      justify-content: space-between;
      width: fit-content;
      background: var(--secondary-background);
      border-radius: 8px;
    `}

  ${(props) =>
    props.isProducts &&
    css`
      min-width: 150px;
      min-height: 42px;
      line-height: 2;
      background: transparent;
      padding: 8px 12px 8px 12px;
      border-radius: 8px;
      box-shadow:
        0 0 0 1px rgba(204, 204, 204, 0),
        0px 0px 0px 1px rgba(0, 0, 0, 0.04),
        0px 1px 4px 0px rgba(0, 0, 0, 0.12);

      &:hover {
        background-color: var(--subtle-background);
      }
    `}


  ${(props) =>
    props.responses &&
    css`
      min-height: 32px;
      background: transparent;
      padding: 8px 12px 8px 12px;
      border-radius: 8px;
      box-shadow:
        0 0 0 1px rgba(204, 204, 204, 0),
        0px 0px 0px 1px rgba(0, 0, 0, 0.04),
        0px 1px 4px 0px rgba(0, 0, 0, 0.12);

      &:hover {
        background-color: var(--subtle-background);
      }
    `}
`;

export const StatisticMenuSettings = styled(Box)`
  display: none;

  position: absolute;
  top: 21px;
  right: -98px;
  z-index: 111;
  color: var(--main-black);
  background: var(--main-background);
  border: 1px solid #959595;
  border-radius: 8px;

  ${(props) =>
    props.show &&
    css`
      display: block;
    `}

  ${(props) =>
    props.modalAnalytics &&
    css`
      top: 28px;
      right: 12px;
      @media (max-width: 480px) {
        padding-top: 12px;
        padding-bottom: 12px;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      top: 43px;
      right: initial;
      left: 1px;
      width: 175px;
    `}

  ${(props) =>
    props.isProducts &&
    css`
      top: 51px;
      left: 0;
      width: 100%;
      right: initial;
    `}

  ${(props) =>
    props.responses &&
    css`
      top: 38px;
      width: 179px;
    `}

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        top: 110%;
      }
    `}
`;

export const StatisticMenuSettingsList = styled(Box)`
  display: flex;
  min-width: 125px;
  flex-direction: column;
  font-size: 14px;
  color: var(--secondary-gray);
  border-radius: 8px;
`;

export const StatisticMenuSettingsItem = styled(Box)`
  display: flex;
  padding: 7px 12px;
  cursor: pointer;

  &:hover {
    border-radius: 8px;
    background: #f9f9f9;
  }
`;

export const StatisticMenuSettingsTitle = styled(Box)`
  margin-left: 10px;
  @media (max-width: 480px) {
    white-space: nowrap;
  }
`;

export const StatisticSubtitle = styled(Box)`
  display: inline-flex;
  font-size: 18px;
  font-weight: bold;
`;

export const HeaderButtonBox = styled(Box)`
  position: relative;
  z-index: 1001;
  margin-left: 25px;

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        margin-left: 0;
        flex: 1;
        width: 100%;
      }
    `}
`;

export const StatisticTotalTitle = styled(Box)`
  font-size: 28px;
  ${(props) =>
    props.withInput &&
    css`
      display: flex;
      flex-direction: column;
      gap: 8px;
    `}

  ${(props) =>
    props.isRight &&
    css`
      margin-right: auto;
    `}

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        font-size: 16px;
        font-weight: bold;
        margin-top: 12px;
        margin-bottom: 12px;
      }
    `}
`;

export const StatisticBox = styled(Box)`
  margin: 24px 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
  color: var(--secondary-gray);

  @media (max-width: 767px) {
    display: none;
  }

  ${(props) =>
    props.gettingAnalyticsStats &&
    css`
      justify-content: center;
    `}

  ${(props) =>
    props.modalAnalytics &&
    css`
      margin: 12px 0;
      width: 100%;

      @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      @media (max-width: 480px) {
        gap: 16px;
      }
    `}

  ${(props) =>
    props.menuItem &&
    css`
      padding: 0 24px;
    `}
`;

export const StatisticItemBox = styled(Box)`
  padding: 24px;
  width: 31.5%;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid var(--border-color, #e5e7eb);

  @media (max-width: 567px) {
    width: 100%;
  }

  ${(props) =>
    props.shop &&
    css`
      display: flex;
      width: 48%;
    `}

  ${(props) =>
    props.menuItem &&
    css`
      width: 18.5%;
      padding: 15px;
    `}

  ${(props) =>
    props.active &&
    css`
      background: #f1f5ff;
    `}

  ${(props) =>
    props.cursorDefault &&
    css`
      cursor: default;
    `}
`;

export const StatisticItemHeader = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StatisticContentBox = styled(Box)`
  margin-left: 20px;

  ${(props) =>
    props.item &&
    css`
      min-height: 45px;
      margin: 0 0 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
    `}
`;

export const StatisticIconBox = styled(Box)`
  background: #eff6ff;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  ${(props) =>
    props.shop &&
    css`
      width: 65px;
      height: 65px;
      background: #f2fcf7;

      svg {
        width: 48px;
      }
    `}

  ${(props) =>
    props.botsIconBox &&
    css`
      width: 35px;
      height: 35px;
    `}
`;

export const StatisticIcon = styled.img`
  width: 24px;

  ${(props) =>
    props.botsIcon &&
    css`
      width: 18px;
    `}
`;

export const StatisticData = styled(Box)`
  margin-top: 4px;
  font-size: 32px;
  font-weight: 700;
  color: var(--main-black);

  ${(props) =>
    props.active &&
    css`
      color: #147cff;
    `}

  ${(props) =>
    props.shop &&
    css`
      margin: 0;
      color: var(--main-black);
      font-weight: bold;
    `}

  ${(props) =>
    props.menuItem &&
    css`
      margin: 0;
      line-height: 1;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const StatisticText = styled(Box)`
  margin-top: 40px;
  font-size: 11px;

  ${(props) =>
    props.menuItem &&
    css`
      margin: 12px 0 0 0;
      font-size: 12px;
      color: var(--secondary-gray);
      line-height: 1.4;
    `}
`;

export const ModalAnalyticsMenuBox = styled(Box)`
  margin-top: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  //outline: 1px solid deeppink;
`;

export const ModalAnalyticsMenuIcon = styled.img`
  width: 30px;
  height: 20px;
  margin-top: -2px;
  padding: 0 10px;

  [data-theme='dark'] & {
    filter: invert(1);
  }

  ${(props) =>
    props.isShowingItems &&
    css`
      transform: rotate(180deg);
    `}

  ${(props) =>
    props.isBlock &&
    css`
      position: absolute;
      top: 50%;
      right: 5px;
      margin-top: -3px;
    `}

  ${(props) =>
    props.chooseDomain &&
    css`
      position: absolute;
      top: 50%;
      right: 2px;
    `}
`;

export const StatisticNumber = styled(Box)`
  font-size: 32px;

  ${(props) =>
    props.center &&
    css`
      font-size: 16px;
      margin: 30% auto;
      width: 100%;
      height: 100%;
      text-align: center;
    `}
`;

export const StatisticTitle = styled(Box)`
  margin-top: 2px;
  font-size: 14px;
  color: var(--secondary-gray);

  ${(props) =>
    props.menuItem &&
    css`
      line-height: 1;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const AdditionalAction = styled(Box)`
  display: none;
  margin-bottom: -10px;
  color: var(--secondary-gray);
  text-align: center;

  ${(props) =>
    props.isHideOnlyMobile &&
    css`
      @media (max-width: 767px) {
        display: block;
      }
    `}

  ${(props) =>
    !props.isHideOnlyMobile &&
    css`
      display: block;
    `}
  
  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

export const UserMenuIconBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  font-size: 18px;

  svg {
    flex: none;
  }

  ${(props) =>
    props.isAccountMenu &&
    css`
      width: 24px;
      height: 24px;
      margin-right: 0;
      margin-left: -3px;
    `}
`;

export const IconSavingValue = styled.img`
  width: 16px;
  height: 16px;
`;

export const UserMenuTitle = styled(Box)`
  color: var(--secondary-gray);
  margin-left: 10px;
  font-size: 15px;

  @media (max-width: 480px) {
    margin-left: 0;
    white-space: nowrap;
    ${(props) =>
      props.isActive &&
      css`
        color: var(--main-black);
      `}
  }

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      width: 80%;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isAccountMenu &&
    css`
      font-size: 14px;
      color: var(--secondary-gray);

      &:hover {
        //color: #a9a9a9;
      }
    `}
`;

export const AdditionalBox = styled(Box)`
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.hide &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}
`;

export const AdditionalBoxHide = styled(Box)`
  ${(props) =>
    props.isHideOnlyMobile &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}

  ${(props) =>
    !props.isHideOnlyMobile &&
    css`
      display: none;
    `}

  ${(props) =>
    props.editBox &&
    css`
      height: 85px;
    `}

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.heading &&
    css`
      position: relative;
      margin-top: -5px;
      padding: 5px 25px 0 25px;
      box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
      border-radius: 8px;

      &:before {
        content: '';
        position: absolute;
        top: -10px;
        left: 0;
        width: 100%;
        height: 24px;
        background: var(--main-background);
      }
    `}
`;

export const AdditionalTitle = styled.span`
  padding: 0 10px;
  display: inline-flex;
  cursor: pointer;

  ${(props) =>
    props.bottom &&
    css`
      margin: 15px 0;
      text-align: center;
      display: flex;
      justify-content: center;
    `}

  ${(props) =>
    props.left &&
    css`
      margin: 30px 0 10px 0;
      text-align: left;
    `}
  

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.sectionHeader &&
    css`
      padding: 15px 15px 15px 25px;
      display: flex;
      justify-content: space-between;
      background: var(--main-background);
      color: var(--secondary-gray);
      box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
      border-radius: 8px;
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      justify-content: space-between;
      padding-left: 25px;
      padding-right: 15px;
    `}

  ${(props) =>
    props.button &&
    css`
      background: #f3f3f3;
      color: var(--secondary-gray);
      width: 200px;
      margin-left: auto;
      margin-right: auto;
      padding: 15px;
      border-radius: 6px;

      @media (max-width: 767px) {
        padding: 10px;
        width: 160px;
      }
    `}

  ${(props) =>
    props.properties &&
    css`
      width: 38%;
      min-width: 98px;
      z-index: 1000;
      position: relative;
    `}
  
  ${(props) =>
    props.tools &&
    css`
      padding: 0;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: var(--secondary-gray);

      span {
        margin-left: 10px;
      }
    `}
`;

export const AdditionalIcon = styled.img`
  width: 30px;
  height: 20px;
  margin-top: 2px;
  padding: 0 10px;

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}

  ${(props) =>
    props.active &&
    css`
      transform: rotate(180deg);
    `}

  ${(props) =>
    props.shopModal &&
    css`
      width: initial;
      height: initial;
      padding: 0;
      margin-top: 3px;
    `}
`;

export const Checkmark = styled.span`
  position: absolute;
  top: -3px;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: transparent;
  border: 1px solid var(--border-color);
  border-radius: 5px;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      opacity: 0.5;
      background-color: var(--overlay-light);
    `}

  ${(props) =>
    props.topCheckMark &&
    css`
      top: ${props.topCheckMark};
    `}
`;

export const RadioCheckmark = styled.span`
  flex: none;
  position: absolute;
  top: -3px;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: transparent;
  border: 2px solid var(--border-color);
  border-radius: 50%;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 1px;
    height: 1px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${(props) =>
    props.notAbsolute &&
    css`
      position: relative;
      top: 0;
      left: 0;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.emailCollect &&
    css`
      display: inline-flex;
      margin: 0 10px 0 0;
    `}

  ${({ size }) =>
    size &&
    css`
      width: ${size};
      height: ${size};
    `}
`;

export const ContentSwitchActiveBox = styled(Box)`
   display: block;
   //margin-top: -5px;
   padding: 16px;
   box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
   border-radius: 8px;
   border-top-left-radius: 0;
   border-top-right-radius: 0;
   margin-bottom: 16px;

  @media (max-width: 568px) {
    padding: 0;
  }

  ${(props) =>
    props.timer &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.hideBoxShadow &&
    css`
      box-shadow: none;
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
        box-shadow: none;
      }
    `}

  ${(props) =>
    props.boxShadowNone &&
    css`
      box-shadow: none;

      @media (max-width: 767px) {
        box-shadow: none;
      }
    `}

  ${(props) =>
    props.insideSetting &&
    css`
      @media (max-width: 568px) {
        padding: 15px;
      }
    `}

  ${(props) =>
    props.isHidden &&
    css`
      display: none;
    `}
  
}
`;

export const PageColorList = styled(Box)`
  // padding-bottom: 10px;
  display: flex;
  //justify-content: space-between;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  ${(props) =>
    props.borderColor &&
    css`
      flex-grow: 1;
      justify-content: flex-end;
      padding: 0;
    `}

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  
  ${(props) =>
    props.pb &&
    css`
      padding-bottom: ${props.pb}px;
    `}
`;

export const MediaHeaderList = styled(Box)`
  display: flex;
`;

export const MediaHeaderItem = styled(Box)`
  cursor: pointer;
  width: 90px;
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background: #f2f6fc;
  border-radius: 15px;

  &:last-child {
    margin-right: 0;
  }

  ${(props) =>
    props.active &&
    css`
      border: 3px #ffc561 solid;
    `}
`;

export const MediaHeaderIcon = styled.img`
  width: 30px;
  height: 30px;

  @media (max-width: 567px) {
    width: 25px;
    height: 25px;
  }
`;

export const MediaHeaderTitle = styled(Box)`
  font-size: 15px;
  margin-top: 10px;
  color: #b4becc;

  @media (max-width: 567px) {
    font-size: 14px;
  }

  ${(props) =>
    props.active &&
    css`
      font-weight: bold;
    `}
`;

export const UploadImage = styled(Box)`
  display: none;

  ${(props) =>
    props.isShowingUpload &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      width: 100%;
      height: 100%;
      margin-left: -1px;
    `}
  
  ${(props) =>
    props.isShowingImage &&
    css`
      display: block;
    `}

  ${(props) =>
    props.uploadFile &&
    css`
      display: flex;
      justify-content: left;
      align-items: center;
      // width: 303px;
      width: 100%;
      height: 152px;
    `}

  ${(props) =>
    props.isCircle &&
    css`
      // width: 100px;
      // height: 100px;
    `}

  ${(props) =>
    props.seoImage &&
    css`
      width: 100%;
      height: 100%;
      align-items: start;
      justify-content: start;
    `}

  ${(props) =>
    props.ifFullWidth &&
    css`
      width: 100%;
    `}
`;

export const HeaderTypeYouTubeLink = styled(Box)`
  display: none;
`;

export const PreviewFileBox = styled(Box)`
  position: relative;
  width: 303px;
  height: 152px;
  overflow: hidden;

  &:hover {
    div {
      display: block;
    }
  }

  @media (max-width: 767px) {
    width: 100%;

    iframe {
      width: 100% !important;
    }
  }

  ${(props) =>
    props.isFullWidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.uploadButtonLink &&
    css`
      width: 82px;
      height: 82px;
      border-radius: 4px;
    `}
  
  ${(props) =>
    props.seoImage &&
    css`
      width: 400px;
      height: 210px;
      border-radius: 8px;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      border-right: 8px;
      width: 100%;
      height: 100%;
    `}

  ${(props) =>
    props.uploadVideoSubpage &&
    css`
      min-height: 155px;
      display: flex;
      width: auto;
      height: auto;
    `}

  ${(props) =>
    props.insideHeaderCover &&
    css`
      margin-top: -15px;
      height: 150px;
    `}

  ${(props) =>
    props.isBigOnMobile &&
    css`
      @media (max-width: 767px) {
        height: 150px;
        width: 300px;
      }
    `}

  ${(props) =>
    props.insideFaq &&
    css`
      @media (max-width: 767px) {
        width: 82px;
      }
    `}

  ${(props) =>
    props.isCircle &&
    css`
      width: 100px;
      height: 100px;
    `}

  ${(props) =>
    props.imageSize &&
    css`
      width: ${props.imageSize};
      height: ${props.imageSize};
    `}

  ${(props) =>
    props.isFavicon &&
    css`
      width: 100px;
      height: 100px;
      border-radius: 8px;
    `}
`;

export const PreviewImage = styled.img`
  transform: translate(0, -20%);
  width: 303px;

  @media (max-width: 767px) {
    width: 100%;
  }

  ${(props) =>
    props.uploadFile &&
    css`
      object-fit: cover;
      height: 100%;
      width: 100%;
      transform: none;
      border-radius: 3px;
    `}

  ${(props) =>
    props.tagImage &&
    css`
      width: 200px;
    `}

  ${(props) =>
    props.uploadButtonLink &&
    css`
      object-fit: cover;
      width: 82px;
      height: 82px;

      @media (max-width: 767px) {
        width: 82px;
      }
    `}

  ${(props) =>
    props.seoImage &&
    css`
      width: 400px;
      height: 210px;
      transform: none;
      object-fit: cover;
      border-radius: 8px;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: none;
      border-radius: 6px;
    `}


  ${(props) =>
    props.insideHeader &&
    css`
      transform: none;
      width: 240px;
      height: 330px;
      object-fit: cover;
      border-radius: 16px;
    `}

  ${(props) =>
    props.darkness &&
    css`
      filter: brightness(${100 - props.darkness}%);
    `}

  ${(props) =>
    props.insideHeaderCover &&
    css`
      transform: none;
      height: 150px;
      object-fit: cover;
      border-radius: 16px;
    `}

  ${(props) =>
    props.isBigOnMobile &&
    css`
      @media (max-width: 767px) {
        width: 100%;
        height: 100%;
        transform: none;
      }
    `}

  ${(props) =>
    props.isCircle &&
    css`
      border-radius: 50%;
    `}

  ${(props) =>
    props.isFavicon &&
    css`
      width: 100px;
      height: 100px;
      border-radius: 8px;
    `}
`;

export const UploadImageLoading = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 303px;
  height: 152px;

  ${(props) =>
    props.uploadButtonLink &&
    css`
      height: auto;
      width: auto;
    `}

  ${(props) =>
    props.custom &&
    css`
      position: absolute;
      top: 0;
    `}

  ${(props) =>
    props.fullSize &&
    css`
      width: 100%;
      height: 100%;
    `}
`;

export const UploadDeleteFile = styled(Box)`
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;

  ${(props) =>
    props.isImageSvg &&
    css`
      right: unset;
      top: 0;
      left: 60px;
    `}
`;

export const ContactBox = styled.img`
  margin-right: 13px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 8px;

  &:last-child {
    margin-right: 0;
  }

  ${(props) =>
    props.social &&
    css`
      margin-right: 0;
    `}
  ${(props) =>
    props.isDropDownImage &&
    css`
      width: 26px;
      height: 26px;
      margin: 0;
    `}
`;

export const IntegrationIconBox = styled(Box)`
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px 0 20px;

  ${(props) =>
    props.googleSheet &&
    css`
      position: absolute;
      top: -3px;
      left: 1px;
      margin: 0 10px 0 0;
    `}

  ${(props) =>
    props.sendPulse &&
    css`
      margin: 0 4px 0 20px;
    `}
    ${(props) =>
    props.isBoxBannerMailingIntegrations &&
    css`
      width: 100%;
      height: 100%;
      margin: 0;
    `}
`;

export const IntegrationIconWrapper = styled(Box)`
  width: 55px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  background: #f2f6fc;
  border-radius: 15px;

  ${(props) =>
    props.active &&
    css`
      border: 3px #ffc561 solid;
    `}
`;

export const ActiveRectangle = styled.div`
  ${({ isActive }) =>
    isActive &&
    css`
      width: 39px;
      height: 66px;
      border: 1px solid #17ce17;
      border-radius: 5px;
      position: absolute;
      top: 10px;
    `}
`;

export const IntegrationIconIMG = styled.img`
  width: 30px;
  height: auto;
  cursor: pointer;

  ${(props) =>
    props.template &&
    css`
      box-shadow: rgba(0, 0, 0, 0.08) 1px 2px 10px;
      border-radius: 4px;
    `}

  ${(props) =>
    props.isActive &&
    css`
      border: 1px solid #17ce17;
      border-radius: 4px;
    `}


  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.borderRadius &&
    css`
      border-radius: ${props.borderRadius};
    `}

  ${(props) =>
    props.isPng &&
    css`
      width: 39px;
      height: 61px;
      display: block;
      margin: 8px auto 11px;

      @media (max-width: 568px) {
        width: 27px;
        height: 42px;
        display: block;
        margin: 6px auto 9px;
      }
    `}

    ${(props) =>
    props.isMap &&
    css`
      height: 71px;
      width: 44px;
      margin-top: 8px;
      margin-bottom: 8px;
    `}
  
  ${(props) =>
    props.gif &&
    css`
      height: 70px;
      width: 44px;
      margin-top: 8px;
      margin-bottom: 8px;
    `}

  ${(props) =>
    props.isMargin &&
    css`
      margin-bottom: 8px;
    `}

  ${(props) =>
    props.insideEmail &&
    css`
      margin-top: 16px;
      margin-bottom: 16px;
    `}

  ${(props) =>
    props.isSubscribe &&
    css`
      height: 65px;
    `}

  ${(props) =>
    props.isContact &&
    css`
      height: auto;
      width: 43%;
      margin-top: 0px;
      margin-bottom: 8px;
    `}
    ${(props) =>
    props.isBannerMailingIntegrations &&
    css`
      width: 100%;
      height: 100%;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      object-fit: cover;
    `}
    ${(props) =>
    props.isTrashImg &&
    css`
      margin-left: auto;
      width: 20px;
      height: 20px;
      marginleft: 10px;
      cursor: pointer;
    `}
    ${(props) =>
    props.isEditImg &&
    css`
      margin-left: auto;
      width: 15px;
      height: 20px;
      marginleft: 10px;
      cursor: pointer;
    `}
    ${(props) =>
    props.isAccount &&
    css`
      width: 28px;
      height: 28px;
      border-radius: 50%;
    `}
`;

export const IntegrationIcon = styled.span`
  width: 30px;
  height: auto;
  cursor: pointer;

  ${(props) =>
    props.marginTop &&
    css`
      margin-top: ${props.marginTop};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.borderRadius &&
    css`
      border-radius: ${props.borderRadius};
    `}

  ${(props) =>
    props.isPng &&
    css`
      width: 39px;
      height: 61px;
      display: block;
      margin: 8px auto 11px;

      @media (max-width: 568px) {
        width: 27px;
        height: 42px;
        display: block;
        margin: 6px auto 9px;
      }
    `}


  ${(props) =>
    props.isTextAlign &&
    css`
      height: 25px;
      display: block;
    `}
`;

export const CustomDesignBox = styled(Box)`
  ${(props) =>
    props.$isNotActive &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: default;
    `}
`;

export const IconDesignMenu = styled(Box)`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    justify-content: space-between;
    gap: 10px;
    flex-wrap: nowrap;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const IconDesignMenuItem = styled(Box)`
  padding: 10px;
  min-height: 48px;
  min-width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background: #f2f6fc;
  border-radius: 15px;
  cursor: pointer;

  @media (max-width: 576px) {
    width: 100%;
    margin-right: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${(props) =>
    props.active &&
    css`
      border: 2px #ffc561 solid;
    `}

  ${(props) =>
    props.large &&
    css`
      gap: 8px;
      width: 120px;
    `}

  ${(props) =>
    props.socialIcon &&
    css`
      width: 60px;
      height: 60px;
    `}
  ${(props) =>
    props.subscribe &&
    css`
      width: 62px;
      height: 48px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.group &&
    css`
      width: 70px;
      max-width: 70px;

      svg {
        transform: rotate(90deg);
      }
    `}
`;

export const IconWrap = styled.img`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const TextWrap = styled.p`
  border-radius: 8px;
  background: rgb(242, 242, 242);
  color: rgba(0, 0, 0, 0.87);
  padding: 16px 24px;
  text-align: justify;
`;

export const UploadBackgroundImageBox = styled(Box)`
  margin-top: 10px;

  ${(props) =>
    props.uploadButtonLink &&
    css`
      display: flex;
      align-items: center;
      margin: 0;
    `}

  ${(props) =>
    props.uploadPreloader &&
    css`
      @media (max-width: 768px) {
        width: 100%;
      }
    `}

  

  ${(props) =>
    props.isShowingUpload &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      margin-top: 0;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    `}
  
  ${(props) =>
    props.backgorundTypeImageBottom &&
    css`
      margin: 20px 0;
      justify-content: flex-start;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PreviewUnilinkContainer = styled(Box)`
  display: none;
  height: 100%;
  margin-top: 32px;

  @media (max-width: 1200px) {
    margin-left: 50px;
  }

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.isStiky &&
    css`
      position: sticky;
      top: 40px;
    `}

  ${(props) =>
    props.preview &&
    css`
      @media (max-width: 576px) {
        display: none;
      }
    `}

  ${(props) =>
    props.isMobile &&
    css`
      @media (max-width: 576px) {
        margin: 50px 0 20px;
        display: block;
      }
    `}
`;

export const PreviewUnilInk = styled(Box)`
  margin-left: auto;
  margin-top: -25px;
  position: sticky;
  top: 20px;
  width: 350px;

  @media (max-width: 576px) {
    width: 320px;
  }

  ${(props) =>
    props.insideMobile &&
    css`
      margin-top: 0;

      @media (max-width: 1200px) {
        display: block;
      }
    `}

  ${(props) =>
    props.isMenu &&
    css`
      margin: 0 0 0 auto;
    `}

  ${(props) =>
    props.isDetails &&
    css`
      margin: 0 0 0 65px;
    `}
`;

export const PreviewUnilinkBox = styled(Box)`
  margin-left: 1px;
  margin-top: 7px;
  position: relative;
  z-index: 100;
  border: none;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
`;

export const PreviewUnilInkImage = styled.img`
  position: absolute;
  top: -5px;
  left: -6.5px;
  width: 343px;
  height: 660px;
  z-index: 101;
  pointer-events: none;

  @media (min-height: 795px) {
    height: 660px;
  }
`;

export const OrderPriceBox = styled(Box)`
  display: flex;
  justify-content: space-between;

  @media (max-width: 568px) {
    flex-direction: column;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const Text = styled(Box)`
  margin: 5px 0;
  color: var(--secondary-gray);
  font-size: 13px;

  ${({ color }) =>
    color &&
    css`
      color: ${color};
      cursor: pointer;
      width: fit-content;
      padding: 0 16px 0 0;
    `}
`;

export const OrderPriceItem = styled(Box)`
  position: relative;

  @media (max-width: 568px) {
    width: 100%;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${(props) =>
    props.instantRedirect &&
    css`
      width: 50%;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: 568px) {
        width: 100%;
      }
    `}
  
  ${(props) =>
    props.tagPrice &&
    css`
      flex-grow: 1;
      margin-right: 15px;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  
  ${(props) =>
    props.isCurrency &&
    css`
      &:after {
        content: '${props.isCurrency}';
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 2px;
        right: 2px;
        width: 50px;
        height: 38px;
        background: var(--secondary-background);
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    `}

  ${(props) =>
    props.isMinutes &&
    css`
      &:after {
        width: 80px;
      }
    `}
`;

export const OrderCurrencyBox = styled(Box)`
  ${(props) =>
    props.isCurrency &&
    css`
      width: 95%;

      &:after {
        content: '${props.isCurrency}';
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 2px;
        right: 6%;
        width: 50px;
        height: 38px;
        background: var(--secondary-background);
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    `}

  ${(props) =>
    props.isCurrencyRight &&
    css`
      width: 100%;

      &:after {
        right: 1px;
      }
    `}
  

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const OrderCheckbox = styled(Box)`
  display: flex;
  justify-content: space-between;
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const OrderCheckboxItem = styled(Box)`
  width: 47%;
  ${({ gap }) =>
    gap &&
    css`
      display: flex;
      flex-direction: column;
      gap: ${gap};
    `}
`;

export const PostPriceBox = styled(Box)`
  display: flex;
  align-items: center;
  height: 16px;
`;

export const PostPrice = styled(Box)`
  min-width: 60px;
  padding: 5px 10px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: rgb(87 209 62);
  border-radius: 30px;

  ${(props) =>
    !props.isZero &&
    css`
      display: none;
    `}
`;

export const Content = styled(Box)`
  width: 600px;

  @media (max-width: 1345px) {
    width: 500px;
  }

  @media (max-width: 992px) {
    width: 100%;
  }

  @media (max-width: 568px) {
    margin-bottom: 80px;
  }

  @media (max-width: 480px) {
    bottom: -15px;
  }

  ${(props) =>
    props.isFullWidth &&
    css`
      width: 100%;
      flex-grow: 1;
    `}

  ${(props) =>
    props.isMarginCenter &&
    css`
      margin: 0 auto;
    `}

  ${(props) =>
    props.isFlexCenter &&
    css`
      justify-content: center;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isAnalytics &&
    css`
      width: 78%;
    `}

  ${(props) =>
    props.isOpenProduct &&
    css`
      width: initial;
      flex-grow: 1;
    `}
`;

export const ContentMenu = styled(Box)`
  display: none;
  width: 630px;

  justify-content: space-between;

  @media (max-width: 1345px) {
    width: 500px;
  }

  @media (max-width: 992px) {
    width: auto;
  }

  @media (max-width: 568px) {
    position: fixed;
    bottom: 0;
    z-index: 9999;
    width: 100%;
    margin: 0 0 0 -15px;
    padding: 5px 0;
    background: var(--main-background);
    border-top: 1px solid rgb(230, 230, 232);
  }

  @media (max-width: 480px) {
    bottom: -15px;
  }

  ${(props) =>
    props.actionMenu &&
    css`
      width: auto;
      margin: 0 0 28px 0;
    `}

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.audienceMenu &&
    css`
      margin: 18px 22px 28px 0;
      justify-content: flex-start;
      align-items: center;
      width: auto;

      @media (max-width: 568px) {
        position: static;
        bottom: 0;
        z-index: 0;
        width: 100%;
        margin: 18px 22px 28px 0;
        padding: 0;
        background: transparent;
        border-top: none;
      }
    `}

  ${(props) =>
    props.buttonLink &&
    css`
      margin: 18px 22px 28px 0;
      justify-content: flex-start;
      align-items: center;
      width: 360px;

      @media (max-width: 768px) {
        position: static;
        bottom: 0;
        z-index: 0;
        width: 100%;
        margin: 0 auto 20px;
        padding: 0;
        background: transparent;
        border-top: none;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const Instructions = styled(Box)`
  cursor: pointer;
  text-decoration: underline;
  color: #007aff;
`;

export const ContentItem = styled(Box)`
  position: relative;
  width: 50%;
  text-align: center;
  cursor: pointer;

  @media (max-width: 568px) {
    margin-bottom: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--subtle-background);

    @media (max-width: 568px) {
      display: none;
    }
  }

  ${(props) =>
    props.active &&
    css`
      font-weight: bold;

      @media (max-width: 568px) {
        font-weight: 400;
      }

      &:after {
        background: #616161;

        @media (max-width: 568px) {
          bottom: -11px;
          left: 50%;
          right: 50%;
          width: 75%;
          height: 5px;
          margin: 0 auto;
          display: block;
          transform: translate(-50%, -50%);
          background: #7954e0;
          border-radius: 18px;
        }
      }
    `}

  ${(props) =>
    props.actionItem &&
    css`
      width: 33.33%;
    `}

   ${(props) =>
    props.order &&
    css`
      order: ${props.order};
    `}

   ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.WebsiteMenuItem &&
    css`
      width: 20%;

      &:after {
        @media (max-width: 568px) {
          display: block;
        }
      }

      @media (max-width: 568px) {
        font-size: 14px;
      }
    `}

   ${(props) =>
    props.active &&
    props.WebsiteMenuItem &&
    css`
      &:after {
        @media (max-width: 568px) {
          background: #ffbc49;
        }
      }
    `}

   ${(props) =>
    props.buttonLink &&
    css`
      width: 50%;

      &:after {
        @media (max-width: 568px) {
          display: block;
        }
      }
    `}

   ${(props) =>
    props.productItem &&
    css`
      width: auto;
      margin-right: 10px;
      padding: 10px 18px;
      cursor: pointer;
      color: var(--main-black);

      &:after {
        display: none;
      }
    `}

   ${(props) =>
    props.productActiveItem &&
    css`
      font-weight: bold;
      background: #f8f2e7;
      border-radius: 8px;
    `}

   ${(props) =>
    props.page &&
    css`
      font-weight: bold;
      align-items: center;
      display: flex;
      justify-content: flex-start;

      @media (max-width: 576px) {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 16px;
        font-size: 18px;
      }

      &:after {
        display: none;
      }
    `}
`;

export const ContentIconBox = styled(Box)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px;
`;

export const ContentIcon = styled.img`
  margin-left: 10px;
  width: 17px;
  height: 17px;

  ${(props) =>
    props.arrow &&
    css`
      width: 14px;
      height: 14px;
    `}

  ${(props) =>
    props.rotate &&
    css`
      transform: rotate(180deg);
    `}
`;

export const ContentBackIcon = styled.img`
  margin-right: 28px;
  width: 30px;
  height: 30px;
  transform: rotate(180deg);
  cursor: pointer;

  ${(props) =>
    props.isHideDesktop &&
    css`
      @media (min-width: 992px) {
        display: none;
      }
    `}

  ${(props) =>
    props.backButtonLink &&
    css`
      position: absolute;
      top: 18px;
      left: 23px;
      width: 25px;
      height: 25px;
    `}

  ${(props) =>
    props.WebsiteMenuItem &&
    css`
      @media (max-width: 568px) {
        left: 10px;
        position: absolute;
        top: -50px;
      }
    `}

     ${({ width }) =>
    width &&
    css`
       {
       width: ${width};
      }
    `}

     ${({ height }) =>
    height &&
    css`
      {
       height: ${height};
      }
    `}

     ${({ margin }) =>
    margin &&
    css`
      {
       margin: ${margin};
      }
    `}

       ${({ top }) =>
    top &&
    css`
      {
       top: ${top};
      }
    `}
`;

export const ContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  ${(props) =>
    props.isPagesBlock &&
    css`
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: start;
    `}
`;

export const WebsiteBox = styled(Box)`
  display: flex;
  justify-content: space-evenly;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const WebsiteContent = styled(Box)`
  position: relative;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  @media (max-width: 568px) {
    width: 100%;
  }
`;

export const ContentDashboard = styled(Box)`
  display: none;
  position: relative;
  width: 630px;
  margin: 0;

  @media (max-width: 1345px) {
    width: 500px;
    min-width: 500px;
  }

  @media (max-width: 992px) {
    min-width: 480px;
  }

  @media (max-width: 576px) {
    margin: 0;
    width: initial;
    min-width: initial;
  }

  @media (max-width: 480px) {
    margin-bottom: 100px;
    width: 100%;
  }

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.isOpenProduct &&
    css`
      margin: 0 0 0 35px;
      width: initial;
    `}

  ${(props) =>
    props.isAddBlockFixed &&
    css`
      margin-bottom: 80px;
      padding-bottom: 20px;
    `}



  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const ContentPageBox = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.flexColumn &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

      ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const ContentPageBoxItem = styled(Box)`
  @media (max-width: 568px) {
    width: 48%;
    flex: none;
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.hiddenResultAction &&
    css`
      width: 100% !important;
    `}
  
  ${(props) =>
    props.activeButton &&
    css`
      @media (max-width: 568px) {
        width: 100% !important;
      }
    `}
`;

export const IntegrationsNotifsList = styled(Box)`
  display: flex;
  justify-content: space-between;

  @media (max-width: 568px) {
    flex-direction: column;
  }
`;

export const IntegrationArrowTitle = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const IntegrationsList = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.arrangementOfBlocks &&
    css`
      display: grid;
      gap: 16px;
      justify-content: center;
      justify-items: center;
      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));

      @media (max-width: 1300px) {
        grid-template-columns: repeat(2, minmax(230px, 1fr));
        justify-items: center;
      }

      @media (max-width: 1150px) {
        grid-template-columns: repeat(1, minmax(225px, 1fr));
        justify-items: left;
      }

      @media (max-width: 940px) {
        grid-template-columns: repeat(1, minmax(225px, 1fr));
        justify-items: center;
      }

      @media (max-width: 570px) {
        grid-template-columns: repeat(2, minmax(180px, 1fr));
        justify-items: center;
      }
    `}
`;

export const IntegrationsItem = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.google &&
    css`
      @media (max-width: 568px) {
        flex-direction: column;
      }
    `}

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
      margin-bottom: 35px;
    `}

  ${(props) =>
    props.isSectionSetting &&
    css`
      justify-content: flex-start;
    `}
    ${(props) =>
    props.boxMailingIntegration &&
    css`
      display: flex;
      flex-direction: column;

      padding: 0;
      border-radius: 8px;
      margin-bottom: 35px;
      width: 100%;
      max-width: 350px;
      height: 320px;
      border-radius: 30px;
      box-shadow: 0px 0px 19px 0px rgba(218, 218, 218, 1);

      @media (max-width: 650px) {
        width: 100%;
        height: 310px;
      }
    `}
`;

export const IntegrationsItemMobile = styled(Box)`
  display: flex;
  margin: 0 0 16px 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  @media (max-width: 576px) {
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  ${(props) =>
    props.isHeaderView &&
    css`
      margin-left: -5px;

      @media (max-width: 768px) {
        flex-wrap: wrap;
      }

      @media (max-width: 576px) {
        flex-wrap: nowrap;
        justify-content: flex-start;
        scale: 0.8;
        width: 130%;
        margin-left: -62px;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isInsideLinks &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.isBanner &&
    css`
      margin-left: -30px;
    `}

  ${(props) =>
    props.isLayoutAlign &&
    css`
      @media (max-width: 576px) {
        justify-content: flex-start;
      }
      margin: 5px 0 12px;
    `}
`;

export const IntegrationsBox = styled(Box)`
 width: 50%;

  @media (max-width: 568px) {
    flex: none;
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.mobileWidth &&
    css`
      @media (max-width: 568px) {
        flex: none;
        width: ${props.mobileWidth};
      }
    `}

  ${(props) =>
    props.orderFields &&
    css`
      @media (max-width: 568px) {
        width: auto;
      }
    `}
  
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

   ${(props) =>
     props.googleSheet &&
     css`
       display: flex;
     `}


   ${(props) =>
     props.google &&
     css`
       @media (max-width: 568px) {
         margin-bottom: 10px;
       }
     `}

  ${(props) =>
    props.telegramPhoto &&
    css`
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}

  ${(props) =>
    props.isInsideStorage &&
    css`
      margin-bottom: 25px;
    `}
    ${(props) =>
      props.boxBannerMailingIntegration &&
      css`
        width: 100%;
        height: 50%;
      `}
  ${(props) =>
    props.boxDescription &&
    css`
      width: 100%;
      padding: 0 16px 5px;
      margin-top: 10px;
    `}
     ${(props) =>
       props.boxDescriptionFlex &&
       css`
         display: flex;
         align-items: center;
       `}
    
    ${(props) =>
      props.boxDescPro &&
      css`
        display: flex;
        width: 100%;
        align-items: center;
      `}
      ${(props) =>
        props.boxPro &&
        css`
          width: 52px;
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          background: #000000;
          border-radius: 30px;
          padding: 3px 0;
          margin-left: auto;

          @media (max-width: 576px) {
            width: 52px;
          }
        `}
        ${(props) =>
          props.boxDisconnect &&
          css`
            width: 100%;
            display: flex;
            justify-content: center;
            padding-bottom: 10px;
            align-items: center;
            margin-bottom: 10px;
            margin-top: 0;
          `}
      ${(props) =>
        props.boxButton &&
        css`
          width: 100%;
          margin-top: auto;
        `};
        
        ${(props) =>
          props.boxConnectedPin &&
          css`
            width: auto;
            background: #ebfcf6;
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            border-radius: 30px;
            padding: 5px 10px;
            margin-left: 5px;
          `};
}`;

export const IntegrationsBoxMobileView = styled(Box)`
  position: relative;
  width: 23%;
  text-align: center;

  @media (max-width: 576px) {
    width: 100%;
  }

  ${(props) =>
    props.isNotPro &&
    css`
      &:after {
        content: 'PRO';
        position: absolute;
        top: 14px;
        right: 3px;
        width: 36px;
        height: 16px;
        background: #39e09b;
        font-size: 9px;
        color: #fff;
        text-align: center;
        line-height: 16px;
        border-radius: 3px;
        margin-top: -10px;
      }
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.headerLayout &&
    css`
      //height: 130px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      //svg {
      //  position: absolute;
      //  top: -35px;
      //  left: -25px;
      //}

      @media (max-width: 768px) {
        width: 48%;
      }

      @media (max-width: 576px) {
        width: 25%;
      }
    `}
  
  ${(props) =>
    props.isInsideHeader &&
    css`
      margin-left: -20px;

      @media (max-width: 768px) {
        margin-left: -5px;
      }
    `}

  ${(props) =>
    props.isInsideLinks &&
    css`
      margin-left: -12px;

      @media (max-width: 768px) {
        margin-left: -12px;
      }
    `}

  ${(props) =>
    props.widthMobile &&
    css`
      @media (max-width: 768px) {
        width: ${props.widthMobile};
      }
    `}

  ${(props) =>
    props.slider &&
    css`
      width: auto;

      @media (max-width: 768px) {
        width: auto;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.alignText &&
    css`
      width: 55px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;

      margin-left: 0;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }

      @media (max-width: 768px) {
        margin-left: 0;
      }

      background: #f2f6fc;
      border-radius: 15px;

      ${(props) =>
        props.active &&
        css`
          border: 3px #ffc561 solid;
        `}
    `}


  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isEmailHeader &&
    css`
      margin-right: 10px;
    `}
`;

export const IntegrationsInputTitle = styled(Box)`
  ${(props) =>
    props.gallery &&
    css`
      margin-top: -10px;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const IntegrationTelegramBox = styled(Box)`
  display: flex;
  align-items: center;

  ${(props) =>
    props.isSectionSetting &&
    css`
      padding: 4px;
      padding-left: 12px;
      background: var(--secondary-background);
      border: 1px solid var(--border-color);
      border-radius: 8px;
    `}
`;

export const IntegrationText = styled(Box)`
  margin-left: 8px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.textForAccount &&
    css`
      width: 100%;
      color: var(--main-black);
    `}
  ${(props) =>
    props.textEmail &&
    css`
      width: 100%;
      color: var(--main-black);
      line-height: revert;
      height: 30px;
    `}
`;

export const IntegrationArrowIconBox = styled(Box)`
  margin-left: auto;
  cursor: pointer;
  padding: 10px;

  ${(props) =>
    props.generateApiKey &&
    css`
      position: absolute;
      right: 0;
      bottom: 44px;
      color: #4e75fe;
      font-size: 14px;
    `}

  ${(props) =>
    props.notification &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-color: var(--main-gray);
      margin-left: 8px;
    `}
`;

export const ListTag = styled(Box)`
  ${(props) =>
    props.scroll &&
    css`
      max-height: 245px;
      overflow-x: auto;
    `}

  ${(props) =>
    props.tagsTikTok &&
    css`
      max-height: 518px;
      overflow-x: auto;
    `}
`;

export const TagItem = styled(Box)`
  position: relative;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid #e9e9e9;

  ${ButtonTransparent} {
    display: none;
    cursor: pointer;
  }

  &:hover ${ButtonTransparent} {
    display: block;
  }

  ${(props) =>
    props.selected &&
    css`
      border-bottom: 2px solid green;
    `}

  ${(props) =>
    props.notActive &&
    css`
      cursor: default;
    `}
`;

export const TagImageBox = styled(Box)`
  width: 55px;
  height: 55px;
  margin-bottom: 15px;
`;

export const TagImage = styled.img`
  width: 55px;
  height: 55px;
  object-fit: cover;
  transition: all 0.3s;
`;

export const TagInfo = styled(Box)`
  margin-left: 10px;
  margin-bottom: 12px;
`;

export const TagDescription = styled(Box)`
  font-size: 15px;
  max-width: 190px;
  max-height: 38px;
  margin-bottom: 5px;
  word-break: break-word;
  overflow: hidden;

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}
`;

export const TagPriceBox = styled(Box)`
  display: flex;
  font-size: 16px;
`;

export const TagPrice = styled(Box)`
  margin-right: 15px;
  //color: #0099FF;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.33px;
  color: var(--main-black);
  line-height: normal;

  ${(props) =>
    props.mediaProduct &&
    css`
      font-size: 16px;
    `}
`;

export const TagOldPrice = styled(Box)`
  //color: var(--secondary-gray);
  position: relative;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.33px;
  color: var(--main-black);
  line-height: normal;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;

    width: 100%;
    height: 2px;
    margin-top: -2px;
    background: #999;
  }
`;

/* Switch */

export const SwitchBox = styled(Box)`
  margin: 0 0 25px 0;
  display: flex;
  align-items: center;

  ${(props) =>
    props.activeLink &&
    css`
      position: absolute;
      top: 14px;
      right: -6px;
      gap: 8px;
      scale: 0.7;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  
  ${(props) =>
    props.hide &&
    css`
      display: none;
      //visibility: hidden;
    `}

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      justify-content: space-between;
      width: 100%;
      padding: 15px;
      background: rgba(0, 0, 0, 0.5);
    `}

  ${(props) =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex};
    `}

  ${(props) =>
    props.reverse &&
    css`
      justify-content: space-between;
      flex-direction: row-reverse;
    `}
`;

export const SwitchTitle = styled(Box)`
  font-size: 16px;
  margin-right: 15px;

  ${(props) =>
    props.center &&
    css`
      display: flex;
      align-items: center;
      gap: 8px;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.showOptions &&
    css`
      font-size: 12px;
      color: #1bc3fe;
      cursor: pointer;
      text-transform: uppercase;
    `}

  ${(props) =>
    props.insideTikTokModal &&
    css`
      color: #fff;
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
`;

export const SwitchBoxContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const SwitchLabel = styled.label`
  flex: none;
  position: relative;
  display: inline-block;
  width: 42px;
  height: 25px;

  ${(props) =>
    props.insideShop &&
    css`
      margin-left: auto;
      margin-right: 5px;
    `}

  ${(props) =>
    props.small &&
    css`
      width: 36px;
      height: 18px;
    `}
  
  ${(props) =>
    props.smallMenu &&
    css`
      width: 32px;
      height: 14px;
    `}

  ${(props) =>
    props.isRight &&
    css`
      position: relative;
      right: -10px;
    `}
`;

export const SwitchSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--main-gray);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 17px;
    width: 17px;
    left: 4px;
    bottom: 4px;
    background-color: var(--main-background);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${(props) =>
    props.small &&
    css`
      &:before {
        height: 17px;
        width: 17px;
        left: 4px;
        bottom: 4px;
      }
    `}

  ${(props) =>
    props.smaller &&
    css`
      &:before {
        height: 12px;
        width: 12px;
        left: 4px;
        bottom: 3px;
      }
    `}


  

  ${(props) =>
    props.product &&
    css`
      &:before {
        height: 12px;
        width: 12px;
        left: 4px;
        bottom: 3px;
      }
    `}
  

  ${(props) =>
    props.smallMenu &&
    css`
      &:before {
        left: 3px;
        bottom: 3px;
        height: 8px;
        width: 8px;
      }
    `}
`;

export const SwitchInput = styled.input`
  display: none;

  &:checked + ${SwitchSpan} {
    background-color: #2196f3;
  }

  &:focus + ${SwitchSpan} {
    box-shadow: 0 0 1px #2196f3;
  }

  &:checked + ${SwitchSpan}:before {
    transform: translateX(18px);
  }

  ${(props) =>
    props.bgGreen &&
    css`
      &:checked + ${SwitchSpan} {
        background-color: #17ce17;
      }
    `}

  ${(props) =>
    props.activeLink &&
    css`
      &:checked + ${SwitchSpan} {
        background-color: #17ce17;
      }
    `}


  ${(props) =>
    props.isSmallMenu &&
    css`
      display: block;
      position: relative;
      z-index: 1000;
      width: 100%;
      opacity: 0;
      cursor: pointer;
    `}
`;

export const ToggleLinkForm = styled(Box)`
  min-height: 20px;
`;

export const EditActionButtonBox = styled(Box)``;

export const EditActionButtonContent = styled(Box)`
  display: flex;

  ${(props) =>
    props.ctaButton &&
    css`
      justify-content: space-between;
      width: 100%;

      @media (max-width: 768px) {
        width: 100%;
      }
    `}
`;

export const QuestionBox = styled(Box)`
  margin-left: 12px;
  cursor: pointer;

  ${(props) =>
    props.inline &&
    css`
      display: inline;
    `}

  ${(props) =>
    props.relativeTooltip &&
    css`
      position: relative;
      z-index: 100;
    `}
`;

export const TimerList = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const TimerItem = styled(Box)`
  width: 48%;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.timerType &&
    css`
      @media (max-width: 768px) {
        margin-top: 16px;
      }
    `}
`;

export const TimerIcon = styled.img`
  margin-right: 8px;
  width: 30px;
  height: 30px;
`;

export const LinksBox = styled(Box)`
  //margin: 0 54px 0 22px;
  margin: 0;

  @media (max-width: 568px) {
    margin: 0;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};

      @media (max-width: 568px) {
        margin: ${props.margin};
      }
    `}
`;

export const SectionContent = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const LinksButtonBox = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const LinkButtonsBox = styled(Box)`
  display: flex;

  @media (max-width: 768px) {
    margin: 12px 0 28px;
    justify-content: space-between;
  }
`;

export const TablerIconsBox = styled(Box)`
  display: block;
  margin-top: 15px;
`;

export const TablerIconsItem = styled(Box)`
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px !important;
  padding: 18px 20px;
  width: 82px;
  height: 82px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 23%;
  }

  ${(props) =>
    props.insideUpload &&
    css`
      @media (max-width: 768px) {
        width: auto;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin} !important;
    `}
  
  ${(props) =>
    props.centerInner &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.resetMargin &&
    css`
      &:nth-child(${props.resetMargin}n + ${props.resetMargin}) {
        margin-right: 0;
      }

      @media (max-width: 768px) {
        margin: 0 0 5px 0;
      }
    `}

  ${(props) =>
    props.insideFaq &&
    css`
      @media (max-width: 767px) {
        width: 100%;
      }
    `}
`;

export const LinkButtonPreviewBox = styled(Box)`
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.insideSection &&
    css`
      margin-top: -45px;

      @media (max-width: 992px) {
        margin-top: 0;
      }
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      margin: 0;

      @media (max-width: 992px) {
        margin: 0;
      }
    `}

  ${(props) =>
    props.isCoupon &&
    css`
      margin-top: 55px;

      @media (max-width: 992px) {
        margin-top: 55px;
      }
    `}

  ${(props) =>
    props.modalLink &&
    css`
      flex: none;
      margin-right: 58px;
      min-width: 450px;
    `}
`;

export const LinkButtonPreviewWrapper = styled(Box)`
  //height: 221px;
`;

export const LinkButtonPreview = styled(Box)`
  width: 450px;
  padding: 35px 20px;
  border: 1px solid var(--border-color);
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.insideHeader &&
    css`
      width: 290px;
      display: flex;
      justify-content: center;
    `}
`;

export const ButtonLinkItem = styled(Box)`
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);

  ${(props) =>
    props.isNotBoxShadow &&
    css`
      box-shadow: none;
    `}

  ${(props) =>
    props.footerItem &&
    css`
      cursor: pointer;
    `}


  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ButtonLinkEditBox = styled(Box)`
  margin-right: 15px;
  display: flex;
  flex-direction: column;

  @media (max-width: 568px) {
    margin-right: 8px;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.social &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 3px;
    `}
`;

export const ButtonLinkContent = styled(Box)`
  display: flex;
  align-items: center;
  flex-grow: 1;
  cursor: pointer;
`;

export const SwitchDotsIcon = styled.img`
  transform: rotate(90deg);
  width: 24px;
  height: 24px;
`;

export const ButtonLinkCircle = styled(Box)`
  margin: 1px;
  width: 4px;
  height: 4px;
  background: #acb5bf;
  border-radius: 50%;

  ${(props) =>
    props.color &&
    css`
      background: ${props.color};
    `}
`;

export const ButtonLinkContainer = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-right: 15px;
  padding: 15px 10px 10px 10px;
  min-height: 90px;
  border-radius: 12px;
  background: var(--main-background);
  border: 1px solid #f7f9ff;
  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);

  &:hover {
    border-color: rgba(197, 215, 253, 0.7);
  }

  @media (max-width: 568px) {
    padding: 10px;
  }

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}
  
  ${(props) =>
    props.isFaqItem &&
    css`
      margin-right: 0;
      padding: 5px 15px;
      min-height: 50px;
      border: 1px solid transparent;
      box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
      border-radius: 8px;

      &:hover {
        border-color: transparent;
      }
    `}
`;

export const ButtonLinkTitle = styled(Box)`
  margin-bottom: 8px;
  max-height: 41px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  font-weight: bold;
  max-width: 360px;

  @media (max-width: 568px) {
    font-size: 16px;
  }

  ${(props) =>
    props.fontWeight &&
    css`
      font-weight: ${props.fontWeight};
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.isNotDescription &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.insideLinks &&
    css`
      margin: 0;
      max-height: 50px;
    `}

  ${(props) =>
    props.isOneLine &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  ${(props) =>
    props.customMusic &&
    css`
      padding: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}

  ${(props) =>
    props.click &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.blog &&
    css`
      max-width: 300px;
    `}

  ${(props) =>
    props.highlight &&
    css`
      // max-width: 300px;
    `}

    ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ButtonLinkDescription = styled(Box)`
  overflow: hidden;

  ${(props) =>
    props.grey &&
    css`
      font-size: 14px;
      color: var(--secondary-gray);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-height: 14px;
    `}

  ${(props) =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
  ${(props) =>
    props.insideLinks &&
    css`
      margin: 5px 0 0 0;
      max-height: 65px;
      font-size: 12px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.customMusic &&
    css`
      font-size: 14px;
    `}

  ${(props) =>
    props.isOneLine &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

export const ButtonLinkWrapper = styled(Box)`
  display: flex;
  width: 100%;
  overflow: hidden;
  ${(props) =>
    props.overflow &&
    css`
      overflow: ${props.overflow};
    `}
`;

export const ButtonIconBox = styled(Box)`
  display: flex;
  flex: none;
  margin-right: 8px;

  ${(props) =>
    props.size &&
    css`
      width: ${props.size};
      height: ${props.size};
    `}
`;

export const ButtonIcon = styled.img`
  width: 38px;
  height: 38px;
  object-fit: cover;

  ${(props) =>
    props.isBigger &&
    css`
      width: 43px;
      height: 43px;
      margin-left: -3px;
    `}

  ${(props) =>
    props.isCircle &&
    css`
      border-radius: 50%;
    `}

  ${(props) =>
    props.isRadius &&
    css`
      border-radius: 8px;
    `}

    ${(props) =>
    props.custom &&
    css`
      margin-left: 7px;
    `}
`;

export const ButtonText = styled(Box)`
  @media (max-width: 568px) {
    width: 70%;
  }

  ${(props) =>
    props.gap &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: ${props.gap};
    `}
`;

export const ButtonLinkMenu = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${(props) =>
    props.isFaqItem &&
    css`
      flex-direction: row;
      margin-left: auto;
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      flex-direction: row;
      margin-left: 0;
    `}

  ${(props) =>
    props.marginMenu &&
    css`
      margin: ${props.marginMenu};
    `}
`;

export const ButtonLinkMenuItem = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background: var(--input-background);
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: #0a3fff;
  }

  &:first-child {
    margin-bottom: 10px;
  }

  ${(props) =>
    props.cover &&
    css`
      position: relative;
      margin: 0 10px;
      background: transparent;

      &:hover {
        background: transparent;
      }
    `}

  ${(props) =>
    props.nohover &&
    css`
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);

      &:hover {
        background: var(--input-background);
      }
    `}

    ${(props) =>
    props.onlyNoHover &&
    css`
      &:hover {
        background: var(--input-background);
      }
    `}

     
  ${(props) =>
    props.isFaqItem &&
    css`
      margin-bottom: 0;
      margin-right: 10px;

      &:first-child {
        margin-bottom: 0;
      }
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      width: 28px;
      height: 28px;
      border-radius: 5px;
    `}

  ${(props) =>
    props.page &&
    css`
      width: 24px;
      height: 24px;
      border-radius: 8px;

      &:first-child {
        margin: 0;
      }
    `}

  

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};

      &:first-child {
        margin: ${props.margin};
      }
    `}

  ${(props) =>
    props.isSettings &&
    css`
      position: absolute;
      z-index: 99;
      top: 50%;
      margin-top: -22px;
      right: 0;
    `}
`;

export const ButtonLinkCategoryImg = styled.img`
  width: 44px;
  height: 44px;
`;

export const ProPlanSettingsBox = styled.div`
  position: relative;
  width: 100%;

  ${(props) =>
    props.position &&
    css`
      position: ${props.position};
    `}
  ${(props) =>
    props.isBigTemplates &&
    css`
      height: 100%;
    `}
`;

export const ProPlanSettings = styled.div`
  ${(props) =>
    props.isNotPro &&
    css`
      pointer-events: none;
      opacity: 0.3;
      user-select: none;
      cursor: not-allowed;

      button,
      a,
      div {
        pointer-events: none !important;
      }
    `}
  ${(props) =>
    props.isBigTemplates &&
    css`
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    `}
`;

export const GetProPlanSettings = styled(Box)`
  //position: absolute;
  //top: 50%;
  position: absolute;
  top: 350px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    props.top &&
    css`
      top: ${props.top};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.messenger &&
    css`
      top: 400px;

      @media (min-width: 568px) and (max-width: 992px) {
        top: 440px;
      }
    `}
`;

export const GetProPlanIcon = styled.img`
  width: 75px;
  height: 85px;
`;

export const AudienceContainer = styled(Box)`
  padding: 0 3rem;

  @media (max-width: 768px) {
    margin: 18px 0 28px 0;
  }

  @media (max-width: 568px) {
    position: relative;
    margin: 40px 0 28px 0;
  }
  @media (max-width: 480px) {
    position: relative;
    margin: 0 0 28px 0;
    padding: 0 0 80px;
  }
`;

export const SectionHeader = styled(Box)`
  display: none;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
      align-items: center;
    `}
`;

export const SectionTitle = styled(Box)`
  font-size: 20px;
`;

export const MediaNetworksCaption = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0 20px 0;

  ${(props) =>
    props.insideLook &&
    css`
      margin: 10px 0 20px 0;
    `}
`;

export const MediaNetworksCaptionBox = styled(Box)`
  display: flex;

  @media (max-width: 992px) {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  @media (max-width: 568px) {
    &:last-child {
      margin-top: 16px;
    }
  }

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.editBox &&
    css`
      @media (max-width: 568px) {
        &:last-child {
          margin-top: 0;
        }
      }
    `}

  ${(props) =>
    props.shopMenu &&
    css`
      width: 100%;
      align-items: center;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.4;
      cursor: default;
      pointer-events: none;
    `}
`;

export const ShopListView = styled(Box)`
  margin-left: auto;
  display: flex;
`;

export const ShopListViewItem = styled(Box)`
  width: 21px;
  height: 21px;
  cursor: pointer;

  &:first-child {
    margin-right: 3px;
  }
`;

export const TikTokList = styled(Box)`
  display: flex;
  flex-wrap: wrap;

  //@media (min-width: 768px) {
  //  margin-left: 20px;
  //}
`;

export const TikTokBox = styled(Box)`
  position: relative;
  margin-right: 10px;
  width: 30.8%;
  height: 0;
  padding-bottom: 56%;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 48%;
    margin-right: 3.5%;
    margin-bottom: 3.5%;
    //padding-top: 2.5%;
    padding-bottom: 85%;
    border-radius: 12px;

    &:nth-child(2n + 2) {
      margin-right: 0;
    }
  }

  ${(props) =>
    props.third &&
    css`
      margin-right: 0;
    `}

  ${(props) =>
    props.editBox &&
    css`
      @media (max-width: 768px) {
        width: 45%;
        padding-bottom: 77%;
        border-radius: 8px;

        img {
          border-radius: 8px !important;
        }
      }
    `}
`;

export const TikTokImg = styled.img`
  display: flex;
  align-self: end;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  -moz-appearance: none;
  -webkit-appearance: none;

  @media (max-width: 768px) {
    border-radius: 12px;
  }
  
  ${(props) =>
    props.checked &&
    css`
      border: 3px #17ce17 solid;
      border-radius: 5%;
      opacity: 1;
    `}
  
  ${(props) =>
    !props.isEdit &&
    css`
      opacity: 0.5;
      filter: grayscale(100%);
    `}

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
    `}

  
  }
`;

export const ModalAddTikTokButtonBox = styled(Box)`
  display: flex;
  justify-content: flex-end;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const TikTokButtonBox = styled(Box)`
  margin: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const TikTokModalImageBox = styled(Box)`
  position: relative;
  width: 345px;

  @media (max-width: 568px) {
    width: 100%;
  }
`;

export const TikTokModalTitle = styled(Box)`
  font-size: 18px;
  font-weight: bold;

  @media (max-width: 768px) {
    margin-top: 15px;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const CustomFormCheckboxList = styled(Box)`
  display: flex;

  ${(props) =>
    props.insideForm &&
    css`
      position: relative;
      margin-top: 15px;
      flex-direction: column;

      &:before {
        content: 'Required';
        position: absolute;
        top: -24px;
        right: 0;
        font-size: 13px;
        color: var(--secondary-gray);
      }
    `}

  ${(props) =>
    props.insideForm &&
    props.required &&
    css`
      position: relative;
      margin-top: 15px;
      flex-direction: column;

      &:before {
        content: '${props.required || "Обов'язково"}'; /* в лапках! */
        position: absolute;
        top: -24px;
        right: 0;
        font-size: 13px;
        color: var(--secondary-gray);
      }
    `}

  ${(props) =>
    props.insideShop &&
    css`
      justify-content: space-between;

      @media (max-width: 768px) {
        justify-content: space-between;
        flex-wrap: wrap;
      }
    `}
`;

export const IconsCheckboxList = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.insideShop &&
    css`
      margin-bottom: 30px;
      justify-content: flex-start;
      flex-direction: column;
    `}
`;

export const IconsCheckboxItem = styled(Box)`
  padding: 3px;
  border-radius: 6px;
  border: 3px solid #f1f1f1;

  width: 32%;
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideShop &&
    css`
      justify-content: flex-start;
      width: 285px;
      margin-bottom: 10px;
    `}
`;

export const IconsCheckboxIconBox = styled(Box)`
  background-color: var(--surface-elevated);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;

  ${(props) =>
    props.insideShop &&
    css`
      flex: none;
    `}
`;

export const CustomFormAddField = styled(Box)`
  margin: 25px 0 25px 13px;
  color: #4e75fe;
  cursor: pointer;
`;

export const CustomFormFieldBox = styled(Box)`
  padding: 20px 0 20px 15px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e8;

  ${(props) =>
    props.noBorder &&
    css`
      border-bottom: none;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const CustomFormFieldTitle = styled(Box)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 150px;

  ${(props) =>
    props.customField &&
    css`
      cursor: pointer;
    `}
`;

export const CustomFormCheckboxItem = styled(Box)`
  width: 33%;

  ${(props) =>
    props.insideForm &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.widthMobile &&
    css`
      @media (max-width: 768px) {
        width: ${props.widthMobile};
      }
    `}

  ${(props) =>
    props.emailCollect &&
    css`
      margin: 20px 0;
      display: flex;
      align-items: center;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const DeleteTikTokBox = styled(Box)`
  margin-right: 24px;

  @media (max-width: 768px) {
    margin: 0;
    width: 48%;
  }
`;

export const CurrencyLangBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const CurrencyBox = styled(Box)`
  width: 48%;
`;

export const DropDownBox = styled(Box)`
  width: 48%;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideBio &&
    css`
      @media (max-width: 1300px) {
        width: 22%;
      }

      @media (max-width: 768px) {
        width: 33%;
      }
    `}

  ${(props) =>
    props.timerStyles &&
    css`
      @media (max-width: 768px) {
        width: 100%;
      }
    `}
`;

export const LangBox = styled(Box)`
  width: 48%;

  @media (max-width: 568px) {
    width: 100%;
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const ExtractButtonBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const ExtractButtonInput = styled(Box)`
  @media (max-width: 768px) {
    width: 65%;
  }
`;

export const ExtractButton = styled(Box)`
  margin-top: 22px;

  @media (max-width: 768px) {
    width: 30%;
    margin-top: 26px;
  }
`;

export const ExtractButtonIcon = styled.img`
  margin-left: 10px;
  width: 15px;
  height: 15px;

  ${(props) =>
    props.buttonLink &&
    css`
      margin: 0;

      @media (max-width: 568px) {
        margin: 0 10px;
      }
    `}
`;

export const PostDisplayBox = styled(Box)`
  margin: 8px 0 22px;
  position: relative;
  z-index: 2;
  width: 57%;

  @media (max-width: 568px) {
    width: 100%;
  }
`;

export const UserContactList = styled(Box)`
  display: flex;
  margin: 0 auto;
  width: 100%;

  ${(props) =>
    props.isSupport &&
    css`
      flex-direction: column;
      padding: 20px 0;
    `}
`;

export const UserContactItemLink = styled.a`
  position: relative;
  padding: 5px;
  flex-basis: 50%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  text-decoration: none;

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  &:only-child {
    flex-basis: 100%;
  }

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.center &&
    css`
      justify-content: center;
      align-items: center;
    `}
 
 ${(props) =>
    props.directMessage &&
    css`
      &:last-child {
        margin-right: 0;
      }
    `}
  
  &:not&:first-child {
    margin-right: 10px;
  }

  ${(props) =>
    props.isSupport &&
    css`
      margin: 0 0 15px 0;
      cursor: pointer;
      height: 50px;
      flex: none;
      font-size: 16px;
    `}
`;

export const UserContactIcon = styled.img`
  width: 35px;
  height: 35px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
      top: 8px;
      left: 20px;
    `}
`;

export const UserContactTitle = styled.span`
  color: #fff;
  ${(props) => props.color && `color: ${props.color};`}
`;

export const ContentSwitchIcon = styled.img`
  width: 18px;
  height: 18px;

  ${(props) =>
    props.isAbsoluteRight &&
    css`
      position: absolute;
      right: 0;
      background: #ebeffe;
      border-radius: 50%;
    `}

  ${(props) =>
    props.isRequest &&
    css`
      width: 22px;
      height: 22px;
    `}

  ${(props) =>
    props.iconSize &&
    css`
      width: ${props.size};
      height: ${props.size};
    `}


  ${(props) =>
    props.title === 'Donations' &&
    css`
      width: 28px;
      height: 28px;
    `}

  ${(props) =>
    props.title === 'Digital goods' &&
    css`
      width: 15px;
      height: 15px;
    `}

  ${(props) =>
    props.title === 'Shipping' &&
    css`
      width: 24px;
      height: 24px;
    `}
`;

export const ContentSwitchTitleText = styled(Box)`
  margin-right: 15px;
  white-space: nowrap;
  min-width: fit-content;

  @media (max-width: 480px) {
    min-width: fit-content;
  }
`;

export const ContentSwitchTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-left: 20px;

  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 38px;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    props.isContent &&
    css`
      align-items: center;
      flex-direction: row;
      flex: 1;
      min-width: 0;
    `}

  ${(props) =>
    props.isNoIcon &&
    css`
      margin-left: 0;
    `}

  ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.subsection &&
    css`
      width: 100%;
      white-space: initial;
    `}
`;

export const ContentSwitchSubtitle = styled.span`
  font-size: 14px;
  line-height: 1.2;
  color: var(--secondary-gray);
  margin-top: 2px;
  white-space: wrap;

  @media (max-width: 576px) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
      }
    `}

  ${(props) =>
    props.isBottom &&
    css`
      position: absolute;
      bottom: -15px;
      left: 5px;
    `}
  ${(props) =>
    props.isShorter &&
    css`
      max-width: 240px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  ${(props) =>
    props.isRelative &&
    css`
      position: relative;
    `}
  ${(props) =>
    props.ellipsis &&
    css`
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}
`;

export const ContentSwitchBox = styled(Box)`
  display: flex;
  align-items: center;
  padding-left: 0;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isNoFlex &&
    css`
      @media (max-width: 568px) {
        flex: none;
      }
    `}

  ${(props) =>
    props.isNoFlexDesctop &&
    css`
      flex: none;
    `}
  
  
  ${(props) =>
    props.noDisplay &&
    css`
      display: none;
    `}
  
  ${(props) =>
    props.click &&
    css`
      cursor: pointer;
      padding: 12px 5px 12px 15px;
      flex-grow: 1;
    `}
  
  ${(props) =>
    props.lock &&
    css`
      cursor: pointer;
      padding: 0 10px;
      flex-grow: 1;
    `}

  

  ${(props) =>
    props.module &&
    css`
      cursor: pointer;
      padding: 12px 5px 12px 0;
      flex-grow: 1;
    `}


  ${(props) =>
    props.dragSection &&
    css`
      @media (max-width: 568px) {
        padding-left: 35px;
      }
    `}

  

  ${(props) =>
    props.isSwitchActive &&
    css`
      // min-width: 130px;
      // flex-basis: 130px;
      justify-content: flex-end;
    `}

  ${(props) =>
    props.isSwitch &&
    css`
      //min-width: 68px;
      //flex-basis: 68px;

      @media (max-width: 568px) {
        min-width: 38px;
        flex-basis: 38px;
      }
    `}

  ${(props) =>
    props.isEditBox &&
    css`
      min-width: 80px;
      flex-basis: 80px;
    `}

  ${(props) =>
    props.isDesignSwitch &&
    css`
      min-width: 30px;
      flex-basis: 30px;
    `}

  ${(props) =>
    props.isAddedSection &&
    css`
      min-width: 30px;
      flex-basis: 30px;
      color: #609afa;
      font-size: 32px;
    `}

  ${(props) =>
    props.isAdded &&
    css`
      color: var(--text-tertiary);
    `}

  ${(props) =>
    props.isNotSection &&
    css`
      //min-width: 68px;
      //flex-basis: 68px;

      @media (max-width: 568px) {
        min-width: 38px;
        flex-basis: 38px;
      }
    `}

  ${(props) =>
    props.insideMedia &&
    css`
      min-width: 37px;
      flex-basis: 37px;

      @media (max-width: 568px) {
        min-width: 38px;
        flex-basis: 38px;
      }
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
        flex-basis: auto;
        min-width: auto;
      }
    `}

  ${(props) =>
    props.isHighlight &&
    css`
      min-width: 140px;
      flex-basis: 140px;

      @media (max-width: 767px) {
        flex-basis: auto;
        min-width: auto;
      }
    `}
  
  ${(props) =>
    props.isShowing &&
    css`
      @media (max-width: 568px) {
        padding-left: 0;
      }
    `}

  ${(props) =>
    props.isRightMobile &&
    css`
      @media (max-width: 568px) {
        position: relative;
        right: -15px;
      }
    `}

  ${(props) =>
    props.isAdded &&
    css`
      opacity: 0.4;
      cursor: default;
    `}
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.linkItem &&
    css`
      scale: 1.7;
      padding: 5px;
      margin-left: 12px;
      position: relative;
      left: 7px;
    `}
`;

export const ContentSwitchIconBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 36px;
  min-width: 36px;
  width: 36px;
  height: 36px;
  background: var(--accent-background);
  border-radius: 50%;

  [data-theme='dark'] & {
    background: rgba(123, 97, 255, 0.15);
  }

  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
    `}
`;

export const ContentSwitchContainer = styled(Box)`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
  border-radius: 8px;
  position: relative;
  padding: 0 2px;

  ${(props) =>
    props.active &&
    css`
      position: relative;
      margin-bottom: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      &:after {
        content: '';
        position: absolute;
        bottom: -15px;
        left: 0;
        width: 100%;
        height: 25px;
        background: var(--main-background);
        z-index: 0;
      }
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.isAddedSection &&
    css`
      cursor: pointer;
      padding: 10px;
    `}

  ${(props) =>
    props.isAdded &&
    css`
      opacity: 0.4;
      cursor: default;
    `}

  ${(props) =>
    props.isNotSoon &&
    css`
      pointer-events: none;
      cursor: default;
    `}

  


  ${(props) =>
    props.isNote &&
    css`
      &:after {
        position: absolute;
        top: 33px;
        right: 50px;
        width: 36px;
        height: 20px;
        font-size: 9px;
        color: #fff;
        text-align: center;
        line-height: 20px;
        border-radius: 10px;
        margin-top: -10px;
      }
    `}


  ${(props) =>
    props.isSoon &&
    css`
      cursor: default;

      &:after {
        content: 'SOON';
        background: #007aff;
      }
    `}

    ${(props) =>
    props.isProPlan &&
    css`
      &:after {
        content: 'PRO';
        background: #39e09b;
      }
    `}

  ${(props) =>
    props.isNotSection &&
    css`
      opacity: 1;
      cursor: pointer;
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
        margin: 12px 0;
        box-shadow: none;
        padding-right: 5px;

        &:after {
          display: none;
        }
      }
    `}

  ${(props) =>
    props.isMarginTop &&
    css`
      margin-top: 15px;
    `}
`;

export const ContentMenuList = styled(Box)`
  display: none;

  @media (max-width: 480px) {
    margin-bottom: 80px;
  }

  ${(props) =>
    props.show &&
    css`
      display: block;
    `}
`;

export const ContentMenuItemHeader = styled(Box)`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.title &&
    css`
      font-size: 22px;
    `}
`;

export const ContentMenuItemTitle = styled(Box)`
  font-size: 20px;
  color: var(--main-black);
`;

export const ContentMenuCaption = styled(Box)``;

export const ContentMenuCaptionText = styled.span`
  position: relative;
  font-size: 14px;
  font-weight: bold;
  color: var(--main-black);

  ${(props) =>
    props.isNotPro &&
    css`
      &:after {
        content: 'PRO';
        position: absolute;
        top: 50%;
        left: calc(100% + 6px);
        transform: translateY(-50%);
        height: 16px;
        background: #17ce17;
        font-size: 9px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        line-height: 16px;
        border-radius: 20px;
        padding: 0 8px;
        white-space: nowrap;
      }
    `}
`;

export const ContentMenuSubcaption = styled(Box)`
  font-size: 12px;
  color: var(--secondary-gray);
`;

export const ContentMenuIcon = styled.img`
  width: 12px;
  transform: rotate(-90deg);

  [data-theme='dark'] & {
    filter: invert(1);
  }
`;

export const IconButtonZapier = styled.img`
  margin-top: -4px;
  width: 64px;
  height: 30px;
  margin-left: 4px;
`;

export const MediaCategories = styled(Box)`
  position: relative;
  ${(props) =>
    props.property &&
    css`
      margin-top: -34px;
    `}
`;

export const MediaCategoriesList = styled(Box)`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const MediaCategoryItem = styled(Box)`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 10px;
  background: var(--main-gray);
  border-radius: 36px;
  padding: 5px 10px;
  cursor: pointer;
  max-width: 330px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.button &&
    css`
      background: transparent;
      border: 1px solid #eeeff1;
    `}

  ${(props) => props.property && css``}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const MediaCategoryIconClose = styled.img`
  margin-top: 1px;
  margin-left: 10px;
  width: 10px;
  height: 10px;

  ${(props) =>
    props.poitner &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.isDigital &&
    css`
      margin-left: 21px;
      margin-top: 5px;
    `}
`;

export const MediaCategoriesHead = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.property &&
    css`
      justify-content: flex-end;
    `}

  ${(props) =>
    props.isSettings &&
    css`
      line-height: 27px;
    `}
`;

export const MediaCategoriesTitle = styled(Box)`
  cursor: pointer;
  color: #00bfff;
  font-size: 13px;
`;

export const ModalCategoriesList = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ModalCategoriesItem = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ModalCategoriesAction = styled(Box)`
  cursor: pointer;
  color: #00bfff;
  text-transform: uppercase;
  font-size: 14px;

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      color: #9393a0;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ContentSwitchHeader = styled(Box)`
  margin-bottom: 30px;

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ContentSwitchHeaderPromo = styled(Box)`
  font-size: 12px;
  line-height: 16px;
`;

export const ContentSwitchHeaderPromoLink = styled.span`
  margin-left: 2px;
  text-decoration: underline;
  color: #00bfff;
  cursor: pointer;
`;

export const MediaPropertiesList = styled(Box)``;

export const MediaPropertiesItem = styled(Box)`
  position: relative;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PropertiesHeading = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isSettings &&
    css`
      line-height: 27px;
    `}
`;

export const PropertiesList = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const LabelsList = styled(Box)`
  margin-left: 10px;
  display: flex;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isWrap &&
    css`
      flex-wrap: wrap;
    `}

  ${(props) =>
    props.isAbsolute &&
    css`
      position: absolute;
      flex-direction: column;
      top: 10px;
      right: 10px;
    `}
  ${(props) =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex};
    `}
`;

export const PropertiesItem = styled(Box)`
  margin-right: 8px;
  margin-bottom: 8px;
  cursor: pointer;

  ${(props) =>
    props.string &&
    css`
      font-size: 14px;
      padding: 7px;
      height: 32px;
      border-radius: 3px;
      border: 1px solid #000;
    `}

  ${(props) =>
    props.color &&
    css`
      min-width: 25px;
      width: 25px;
      height: 25px;
      background: ${props.background};
      border-radius: 3px;
      border: 1px solid ${props.background === 'white' || props.background === '#fff' || props.background === '#ffffff' ? '#E0E2E9;' : props.background};
    `}

  

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideMediaColor &&
    css`
      margin: 0;
    `}


  ${(props) =>
    props.insideMediaColor &&
    css`
      height: 20px;
      width: 20px;
      max-width: 20px;
      min-width: initial;
      margin: 0;
      padding: 0;
      border-radius: 50%;
    `}

  ${(props) =>
    props.insideMediaString &&
    css`
      margin: 0;
      padding: 0;
      border: none;
      height: initial;
    `}


  ${(props) =>
    props.label &&
    css`
      display: flex;
      align-items: center;
      padding: 5px 10px;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: bold;
      border-radius: 36px;
      border: 1px solid var(--border-color);
    `}

  ${(props) =>
    props.backgroundColor &&
    css`
      background: ${props.backgroundColor};
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.labelItem &&
    css`
      padding: 0 10px;
      width: auto;
      min-width: initial;
      max-width: initial;
      text-transform: uppercase;
      font-weight: bold;
      border-radius: 36px;
    `}

  ${(props) =>
    props.activeColor &&
    css`
      position: relative;
      border: 3px #17ce17 solid;

      &:before {
        position: absolute;
        top: -9px;
        right: -9px;
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #17ce17;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;opacity:0;%7D.cls-2%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Echeckmark%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='checkmark'%3E%3Cg id='checkmark-2' data-name='checkmark'%3E%3Crect class='cls-1' width='24' height='24'/%3E%3Cpath class='cls-2' d='M9.86,18a1,1,0,0,1-.73-.32L4.27,12.51a1,1,0,1,1,1.46-1.37l4.12,4.39,8.41-9.2a1,1,0,1,1,1.48,1.34l-9.14,10a1,1,0,0,1-.73.33Z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    `}

  ${(props) =>
    props.activeString &&
    css`
      position: relative;
      border: 1px #17ce17 solid;

      &:before {
        position: absolute;
        top: -9px;
        right: -9px;
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #17ce17;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;opacity:0;%7D.cls-2%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Echeckmark%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='checkmark'%3E%3Cg id='checkmark-2' data-name='checkmark'%3E%3Crect class='cls-1' width='24' height='24'/%3E%3Cpath class='cls-2' d='M9.86,18a1,1,0,0,1-.73-.32L4.27,12.51a1,1,0,1,1,1.46-1.37l4.12,4.39,8.41-9.2a1,1,0,1,1,1.48,1.34l-9.14,10a1,1,0,0,1-.73.33Z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    `}

  ${(props) =>
    props.digital &&
    css`
      margin-left: 0;
      margin-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 10px;
      height: 25px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.isAbsolute &&
    css`
      margin-bottom: 10px !important;
    `}

    ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
      text-align: center;
      display: block;
    `}
    ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `}
`;

export const ModalTitleBox = styled(Box)`
  display: flex;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ModalTitleItem = styled(Box)`
  ${(props) =>
    props.dropwdown &&
    css`
      width: 100px;
      flex: none;
    `}

  ${(props) =>
    props.title &&
    css`
      width: 100%;
      margin-left: 18px;
    `}
`;

export const ModalPropertiesList = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ${(props) =>
    props.viewLabel &&
    css`
      overflow-y: initial;
    `}
`;

export const ModalPropertiesItem = styled(Box)``;

export const ModalPropertiesInputBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow-y: auto;

  ${(props) =>
    props.viewLabel &&
    css`
      overflow-y: initial;
    `}
`;

export const ButtonShapeBox = styled(Box)`
  margin: 10px 0 16px;
  display: flex;
  justify-content: start;
  gap: 16px;
  width: 100%;

  ${(props) =>
    props.postShadow &&
    css`
      justify-content: flex-start;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ImageShapeList = styled(Box)`
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 14px;
    justify-content: normal;
  }
`;

export const ImageShapeItem = styled(Box)`
  //margin-top: -45px;
  height: 100px;
  cursor: pointer;

  @media (max-width: 576px) {
    height: 65px;
  }
`;

export const BackgroundImageSearchBox = styled(Box)``;

export const BackgroundImageSearchInputBox = styled(Box)`
  position: relative;
`;

export const BackgroundImageSearchIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const BackgroundImageSearchIconBox = styled(Box)`
  padding: 6px 0;
  position: absolute;
  top: 0;
  right: 3px;
  width: 40px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 3px;
  //outline: 1px solid deeppink;
`;

export const BackgroundImageText = styled(Box)`
  margin: 8px 0;
  font-size: 12px;
`;

export const BackgroundImageList = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  ${(props) =>
    props.isUserMediaLibrary &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    `}
`;

export const BackgroundImageUnsplash = styled.img`
  margin-right: 5.8px;
  margin-bottom: 5.8px;

  width: 24%;
  cursor: pointer;
  border-radius: 8px;
  object-fit: cover;

  &:nth-child(4n + 4) {
    margin-right: 0;
  }

  @media (max-width: 568px) {
    height: 104px;
    width: 23.5%;
  }

  ${(props) =>
    props.active &&
    css`
      border: 2px solid #ffbc49;
    `}

  ${(props) =>
    props.isUserMediaLibrary &&
    css`
      width: 120px;
      height: 120px;
    `}
`;

export const BackgroundVideoCoverr = styled.video`
  margin-right: 5.8px;
  margin-bottom: 5.8px;

  width: 24%;
  cursor: pointer;
  border-radius: 8px;
  object-fit: cover;

  &:nth-child(4n + 4) {
    margin-right: 0;
  }

  @media (max-width: 568px) {
    height: 130px;
    width: 23.5%;
  }

  ${(props) =>
    props.active &&
    css`
      border: 2px solid #ffbc49;
    `}
`;

export const BackgroundImageButtonBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const BackgroundImageSpinner = styled(Box)`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackgroundImageEmptyBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderAvatarImageBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const FlexBox = styled(Box)`
  display: flex;

  ${(props) =>
    props.center &&
    css`
      justify-content: center;
      align-items: center;
    `}
  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}
  ${(props) =>
    props.alignItems &&
    css`
      align-items: ${props.alignItems};
    `}
  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.gap &&
    css`
      gap: ${props.gap};
    `}
  ${(props) =>
    props.wrap &&
    css`
      flex-wrap: ${props.wrap};
    `}
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
  ${(props) =>
    props.relative &&
    css`
      position: relative;
    `}
`;

export const ModalLink = styled(Box)`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
`;

export const InputAutofillItem = styled(Box)`
  // display: flex;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.linkType &&
    css`
      flex: none;
    `}

  ${(props) =>
    props.downloadLink &&
    css`
      width: 90px;
    `}

  ${(props) =>
    props.appointment &&
    css`
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    `}

  ${({ soon }) =>
    soon &&
    css`
      background-color: rgb(255, 169, 0);
      color: rgb(255, 255, 255);
      border-radius: 12px;
      text-transform: uppercase;
      text-align: center;
      font-size: 12px;
      padding: 4px 5px;
      width: 12%;
    `}
`;

export const SubpageItemEditBox = styled(Box)`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 30px;
  height: 30px;

  justify-content: center;
  align-items: center;
`;

export const SubpageItemEditCover = styled(Box)`
  background: linear-gradient(0deg, #00000066, #00000066);
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

export const SubpageItemPreview = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
`;

export const SettingsBox = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      width: ${props.margin};
    `}
`;

export const SettingsLink = styled(Box)`
  margin-top: 10px;
  font-size: 14px;
  color: #007aff;
  cursor: pointer;
`;

export const SettingsBoxItem = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const SpinnerContainer = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  background: var(--main-background);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ContentTitleBox = styled(Box)`
  position: absolute;
  top: -110px;
  width: 100%;
  height: 80px;
  padding-left: 3rem;
  padding-top: 20px;
  font-size: 30px;
  border-bottom: 1px solid rgb(230, 230, 232);

  @media (max-width: 480px) {
    position: static;
    padding-left: 0;
    padding-top: 0;
    border-top: 1px solid rgb(230, 230, 232);
    height: auto;
  }
  // @media (max-width: 992px) {
  //   display: none;
  // }

  ${(props) =>
    props.top &&
    css`
      top: ${props.top};
    `}

  ${(props) =>
    props.isMenu &&
    css`
      padding: 36px 0 0;
      display: flex;
      justify-content: center;
    `}
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}

  ${(props) =>
    props.isMenu &&
    css`
      padding: 36px 0 0;
      display: flex;
      justify-content: center;
    `}
  ${(props) =>
    props.isEmail &&
    css`
      padding: 36px 0 0;
      display: flex;
      justify-content: start;
      width: 80%;
    `}


  ${(props) =>
    props.isSectionMenu &&
    css`
      width: auto;
    `}

  ${(props) =>
    props.isStatic &&
    css`
      position: static;
    `}
`;

export const WebsiteMenu = styled(Box)`
  margin-left: -70px;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  line-height: normal;
  width: 600px;
  gap: 1.5rem;

  @media (max-width: 576px) {
    justify-content: space-between;
    align-items: center;
    gap: 0;
    width: 100%;
    margin: 0 0 32px;
  }

  ${(props) =>
    props.isFixedMenu &&
    css`
      width: 100%;
      margin-left: 302px;
    `}

  ${(props) =>
    props.isAudienceMenu &&
    css`
      position: absolute;
      top: -75px;
      margin-left: -70px;
      width: fit-content;
      height: 45px;
      border-bottom: 1px solid rgb(230, 230, 232);
      width: 80%;
      padding-left: 70px;

      @media (max-width: 480px) {
        width: 100%;
        margin-left: 0;
        top: 0;
        flex-direction: column;
        background: var(--main-background);
        justify-content: flex-start;
      }
    `}

  ${(props) =>
    props.isHidden &&
    css`
      display: none;
    `}
  ${(props) =>
    props.isProduct &&
    css`
      width: initial;
      margin: 0 0 32px;
      border-bottom: 1px solid rgb(230, 230, 232);
    `}

  ${(props) =>
    props.isMenu &&
    css`
      gap: 0.5rem;
      border-bottom: none;
    `}

  ${(props) =>
    props.isEmailMenu &&
    css`
      margin-left: 20px;
    `}
`;

export const ContentImage = styled.img`
  width: 100%;
  display: block;
  margin: 0 auto;
`;

export const ContentProBox = styled(Box)`
  display: none;
  justify-content: center;
  margin-top: 150px;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
      @media (max-width: 480px) {
        flex-direction: column-reverse;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isList &&
    css`
      justify-content: flex-start;
      margin-left: 50px;
      @media (max-width: 480px) {
        margin-left: 0;
      }
    `}
`;

export const ContentProPromo = styled(Box)`
  width: 340px;
  margin-top: 40px;
  margin-right: 60px;
  padding: 0 0 60px;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    width: 100%;
    margin-top: 16px;
    margin-right: 0;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  ${(props) =>
    props.promotion &&
    css`
      width: 410px;
    `}
`;

export const ContentProTitle = styled(Box)`
  font-weight: 600;
  font-size: 30px;
  line-height: 1.2;

  ${(props) =>
    props.promotion &&
    css`
      font-size: 34px;
    `}
`;

export const ContentProText = styled(Box)`
  margin: 18px 0 30px 0;
  font-size: 18px;
  line-height: 1.5;
  color: var(--main-black);
  @media (max-width: 480px) {
    text-align: justify;
  }
`;

export const ContentProImageBox = styled(Box)`
  width: 330px;
  height: 400px;

  ${(props) =>
    props.promotion &&
    css`
      margin-top: -100px;
      width: 500px;
      height: 450px;
    `}

  ${(props) =>
    props.wallet &&
    css`
      margin-top: -100px;
      width: 500px;
      height: auto;

      @media (max-width: 480px) {
        width: 100vw;
        height: auto;
      }
    `}
`;

export const SpinnerBox = styled(Box)`
  margin-left: 8px;
`;

export const HighlightSectionBox = styled(Box)`
  display: none;
  margin-top: 20px;
  align-items: center;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const HighlightSectionIconBox = styled(Box)`
  width: 28px;
  height: 28px;
  margin-right: 10px;
  cursor: pointer;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.blockMenu &&
    css`
      width: 24px;
      height: 24px;
    `}
`;

export const ShopProductsBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ShopProductsImageBox = styled(Box)``;

export const ShopProductsImage = styled.img`
  width: 275px;
  height: auto;
`;

export const PaymentSettingBox = styled(Box)`
  display: none;
  margin-top: 30px;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PaymentSettingText = styled(Box)`
  margin: 15px 0;
  font-size: 14px;
  color: var(--secondary-gray);
`;

export const ButtonWrapper = styled(Box)`
  ${(props) =>
    props.stripeConnect &&
    css`
      display: flex;
    `}
`;

export const PaymentSettingTitleBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const PaymentSettingIcon = styled.img`
  width: 24px;
  height: auto;
`;

export const DonationWrapper = styled(Box)``;

export const DonationBox = styled(Box)`
  display: flex;
`;

export const DonationAmountsBox = styled(Box)`
  margin-bottom: 50px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const DonationEmojiBox = styled(Box)`
  width: 54px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const DonationEmoji = styled(Box)`
  margin-left: 10px;
  font-size: 32px;
  cursor: pointer;

  span {
    position: relative;
    top: 7px;
    width: 32px;
    height: 22px;
  }
`;

export const DonationInputBox = styled(Box)`
  max-width: 150px;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`;

export const DonationList = styled(Box)`
  display: flex;
  margin-left: 15px;
  margin-top: 25px;

  @media (max-width: 568px) {
    margin-left: 0;
  }
`;

export const DonationItem = styled(Box)`
  padding: 5px 10px;
  margin-right: 8px;
  display: flex;
  font-size: 14px;
  cursor: pointer;
  background-color: var(--surface-elevated);
  border-radius: 20px;

  align-items: center;
  gap: 4px;
`;

export const DonationItemEmoji = styled(Box)`
  display: flex;
  align-items: center;

  span {
    margin-right: 3px;
    width: 16px;
    height: 12px;
  }
`;

export const DonationItemTitle = styled(Box)``;

export const AddBlockButtonBox = styled(Box)`
  position: relative;
  z-index: 1;
  margin-top: 30px;
  display: none;
  
  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.isAddBlockFixed &&
    css`
      position: fixed;
      width: 600px;
      bottom: 20px;
    `}
}
  
`;

export const DeleteSectionBox = styled(Box)`
  width: 30px;
  flex: none;
  cursor: pointer;

  ${(props) =>
    props.hide &&
    css`
      visibility: hidden;

      @media (max-width: 568px) {
        display: none;
      }
    `}

  ${(props) =>
    props.subsection &&
    css`
      margin-left: auto;
    `}

  ${(props) =>
    props.blockMenu &&
    css`
      width: 24px;
      height: 24px;
    `}

  ${(props) =>
    props.smallMenu &&
    css`
      width: 18px;
      height: 18px;
    `}
`;

export const ProductsList = styled(Box)`
  margin-top: 15px;
  overflow: auto;
  max-height: ${(props) => (props.maxHeight ? `${props.maxHeight}px` : '300px')};

  ${(props) =>
    props.mediaProduct &&
    css`
      margin-top: 4px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ProductsItem = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
  padding-right: 10px;

  ${(props) =>
    props.active &&
    css`
      background: rgb(248, 242, 231);
      border-radius: 3px;
    `}
`;

export const ProductsImage = styled.img`
  width: 48px;
  height: 48px;
  border: 1px solid var(--border-color);
  border-radius: 3px;

  ${(props) =>
    props.mediaProduct &&
    css`
      width: 78px;
      height: 78px;
    `}
`;

export const ProductsTitle = styled(Box)`
  margin-left: 15px;
  font-size: 12px;
  color: rgb(0, 153, 255);

  ${(props) =>
    props.mediaProduct &&
    css`
      max-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 0 3px 0;

      font-size: 15px;
      font-weight: bold;
      color: var(--main-black);
    `}
`;

export const ProductsPrice = styled(Box)`
  margin-left: auto;
  font-size: 18px;
`;

export const ProductsButton = styled(Box)`
  cursor: pointer;
  color: rgb(20, 124, 255);
`;

export const MediaGalleryList = styled(Box)`
  display: flex;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
      height: ${props.width}px;
    `}

  ${(props) =>
    props.isPreview &&
    css`
      margin-left: 8px;
    `}
`;

export const MediaGalleryItem = styled(Box)`
  position: relative;
  width: 60px;
  height: 60px;
  margin-right: 10px;
  cursor: pointer;

  ${(props) =>
    props.product &&
    css`
      margin-bottom: 10px;
    `}

  ${(props) =>
    props.isDigital &&
    css`
      margin-bottom: 10px;
      width: 150px;
      height: 150px;
      border-radius: 8px;
      overflow: hidden;
    `}

  ${(props) =>
    props.isShop &&
    css`
      overflow: hidden;
      border-radius: 8px;
    `}
`;

export const MediaGalleryImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 3px;
  object-fit: cover;
`;

export const MediaGalleryClose = styled(Box)`
  position: absolute;
  right: 3px;
  top: 3px;
  width: 22px;
  height: 22px;
  background: var(--main-background);
  border-radius: 50%;

  &:before,
  &:after {
    position: absolute;
    left: 10px;
    top: 5px;
    content: ' ';
    height: 12px;
    width: 2px;
    background-color: var(--main-black);
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

export const IconLogo = styled.img`
  margin-right: 10px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${(props) =>
    props.chooseImage &&
    css`
      width: 400px;

      @media (max-width: 568px) {
        width: 100%;
      }
    `}
`;

export const ModalContentAddInstagram = styled(Box)`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 20px;
  }
`;

export const IntegrationsButtons = styled(Box)`
  display: flex;

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

export const IntegrationsButtonsWrap = styled(Box)`
  margin-right: 15px;

  @media (max-width: 768px) {
    margin: 0;
    width: 48%;
  }
`;

export const FaqList = styled(Box)`
  margin: -20px 0 30px;
`;

export const Footer = styled(Box)`
  padding: 0 10px;
`;

export const List = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.fixHeight &&
    css`
      height: ${props.fixHeight}px;
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      justify-content: space-between;
    `}
  
  ${(props) =>
    props.isFlex &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.subscribe &&
    css`
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
    `}

  ${(props) =>
    props.isHeader &&
    css`
      @media (max-width: 1350px) {
        flex-wrap: wrap;
      }
    `}

  ${(props) =>
    props.isHeaderButtons &&
    css`
      @media (max-width: 576px) {
        flex-direction: column;
        gap: 20px;
      }
    `}
`;

export const ListItem = styled(Box)`
  width: 33%;
`;

export const MainSection = styled(Box)`
  display: block;
  ${({ hide }) =>
    hide &&
    css`
      display: none;
    `}
`;

export const SubsectionHeader = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const SectionBodyMenuBox = styled(Box)``;

export const SectionBodyMenuList = styled(Box)`
  display: flex;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isHideTabs &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
  ${(props) =>
    props.noDisplay &&
    css`
      display: none;
    `}
  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}
  ${(props) =>
    props.gap &&
    css`
      gap: ${props.gap};
    `}
`;

export const SectionBodyMenuItem = styled(Box)`
  margin-right: 10px;
  padding: 12px 30px;
  font-size: 16px;
  cursor: pointer;
  color: var(--main-black);
  line-height: 1.4;
  align-items: center;

  @media (max-width: 768px) {
    width: 32%;
    padding: 12px 0;
    text-align: center;
  }

  @media (max-width: 576px) {
    margin: 0;
    width: 100%;
  }

  ${(props) =>
    props.isUserMediaLibrary &&
    css`
      padding: 12px 8px;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.center &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    `}
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isProduct &&
    css`
      padding: 12px 24px;
      font-size: 14px;
    `}

    ${(props) =>
    props.active &&
    css`
      font-weight: bold;
      color: #fff;
      background: #1c1c1c;
      border-radius: 8px;
    `}
`;

export const SectionBodyList = styled(Box)``;

export const SplashScreenContent = styled(Box)`
  margin-bottom: 100px;

  ${(props) =>
    props.isChooseProduct &&
    css`
      margin-bottom: 43px;
    `}
`;

export const SplashScreenText = styled(Box)`
  margin-bottom: 10px;
  font-size: 15px;

  ${(props) =>
    props.isWarning &&
    css`
      font-weight: bold;
      color: red;
    `}
`;

export const SplashScreenLink = styled(Box)`
  text-decoration: underline;
  font-size: 15px;
  color: #1f3fff;
  cursor: pointer;

  ${(props) =>
    props.isWarning &&
    css`
      color: #0b67c8;
      font-weight: bold;
    `}
`;

export const ShopItemsList = styled(Box)`
  min-height: 500px;

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}
`;

export const SectionsItem = styled(Box)`
  position: relative;
`;

export const SectionDragIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const ComponentBox = styled(Box)`
  ${(props) =>
    props.isMarginBottom &&
    css`
      margin-bottom: 137px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const InputRadioTitle = styled(Box)`
  margin-left: 15px;
`;

export const CropImageBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;

  img {
    max-height: 430px;
  }
`;

export const InputBox = styled(Box)`
  display: flex;
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const Wrapper = styled(Box)`
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `};
  ${({ position }) =>
    position &&
    css`
      position: ${position};
      z-index: 100;
    `};
`;

export const SettingLink = styled(Box)`
  cursor: pointer;
  font-size: 14px;
  color: #4e75fe;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const SettingsList = styled(Box)`
  display: flex;

  @media (max-width: 568px) {
    margin-top: 10px;
    justify-content: space-between;
  }

  ${(props) =>
    props.downloads &&
    css`
      //position: absolute;
      display: inline-flex;
      margin-left: auto;
      right: 20px;
      top: 18px;
      z-index: 100;

      @media (max-width: 768px) {
        position: static;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        margin-top: 0;
        margin-left: 0;
      }
    `}
`;

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  overflow: hidden;

  @media (max-width: 568px) {
    flex-direction: column;
  }

  ${(props) =>
    props.downloads &&
    css`
      margin: 0;
      align-items: center;
    `}
  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
        overflow: visible;
      }
    `}

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}
`;

export const SettingsItem = styled(Box)`
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 15px;
  cursor: pointer;
  font-size: 13px;

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        height: 42px;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

    ${(props) =>
    props.responses &&
    css`
      height: 32px;
      padding: 6px 12px 6px 8px;
      border-radius: 8px;
      box-shadow:
        0 0 0 1px rgba(204, 204, 204, 0),
        0px 0px 0px 1px rgba(0, 0, 0, 0.04),
        0px 1px 4px 0px rgba(0, 0, 0, 0.12);

      &:hover {
        background-color: var(--subtle-background);
      }
    `}

    ${(props) =>
    props.audience &&
    css`
      width: 260px;
      padding: 8px;

      &:hover {
        background: unset;
      }
    `}
`;

export const SettingsIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 10px;

  ${(props) =>
    props.loupe &&
    css`
      width: 17px;
      height: 17px;
      margin-right: 0;
    `}

  ${(props) =>
    props.close &&
    css`
      margin-right: 0;
    `}
`;
